import * as v from "valibot";
//#region src/RTDBPath.ts
let RTDBPath;
(function(_RTDBPath) {
	const join = (root, ...subPaths) => {
		return [root, ...subPaths].join("/");
	};
	let Firebase;
	(function(_Firebase) {
		_Firebase.serverTimeOffsetPath = () => ".info/serverTimeOffset";
		_Firebase.connectedPath = () => ".info/connected";
	})(Firebase || (Firebase = _RTDBPath.Firebase || (_RTDBPath.Firebase = {})));
	let DataMigration;
	(function(_DataMigration) {
		const DataMigrationPath = "data-migration";
		_DataMigration.dataMigrationPath = () => DataMigrationPath;
		const jobsPath = _DataMigration.jobsPath = () => join(DataMigrationPath, "jobs");
		const jobPath = _DataMigration.jobPath = (jobId) => join(jobsPath(), jobId);
		_DataMigration.jobFinishedPath = (jobId) => join(jobPath(jobId), "finished");
		_DataMigration.taskCreatingStatusPath = (jobId) => join(DataMigrationPath, "task-creating-status", jobId);
		const taskCreatingTriggersPath = _DataMigration.taskCreatingTriggersPath = (jobId) => join(DataMigrationPath, "task-creating-triggers", jobId);
		const taskCreatingTriggerPath = _DataMigration.taskCreatingTriggerPath = (jobId, triggerId) => join(taskCreatingTriggersPath(jobId), triggerId);
		_DataMigration.taskCreatingTriggerInvokedAtPath = (jobId, triggerId) => join(taskCreatingTriggerPath(jobId, triggerId), "invokedAt");
		const tasksPath = _DataMigration.tasksPath = (jobId) => join(DataMigrationPath, "tasks", jobId);
		const initialTasksPath = _DataMigration.initialTasksPath = (jobId) => join(tasksPath(jobId), "initial");
		const initialTaskPath = _DataMigration.initialTaskPath = (jobId, taskId) => join(initialTasksPath(jobId), taskId);
		const alreadyAppliedTasksPath = _DataMigration.alreadyAppliedTasksPath = (jobId) => join(tasksPath(jobId), "already-applied");
		_DataMigration.alreadyAppliedTaskPath = (jobId, taskId) => join(alreadyAppliedTasksPath(jobId), taskId);
		const appliedTasksPath = _DataMigration.appliedTasksPath = (jobId) => join(tasksPath(jobId), "applied");
		_DataMigration.appliedTaskPath = (jobId, taskId) => join(appliedTasksPath(jobId), taskId);
		const failedTasksPath = _DataMigration.failedTasksPath = (jobId) => join(tasksPath(jobId), "failed");
		_DataMigration.failedTaskPath = (jobId, taskId) => join(failedTasksPath(jobId), taskId);
		_DataMigration.taskInvokedAtPath = (jobId, taskId) => join(initialTaskPath(jobId, taskId), "invokedAt");
		const changeSetsPath = _DataMigration.changeSetsPath = (jobId) => join(DataMigrationPath, "task-change-sets", jobId);
		_DataMigration.changeSetPath = (jobId, taskId) => join(changeSetsPath(jobId), taskId);
		let PerformanceTestData;
		(function(_PerformanceTestData) {
			const PerformanceTestDataPath = join(DataMigrationPath, "performance-test-data");
			_PerformanceTestData.performanceTestDataPath = () => PerformanceTestDataPath;
			_PerformanceTestData.performanceTestDataItemPath = (id) => join(PerformanceTestDataPath, id);
		})(PerformanceTestData || (PerformanceTestData = _DataMigration.PerformanceTestData || (_DataMigration.PerformanceTestData = {})));
	})(DataMigration || (DataMigration = _RTDBPath.DataMigration || (_RTDBPath.DataMigration = {})));
	let ActionLog;
	(function(_ActionLog) {
		const ActionLogPath = "action-log";
		_ActionLog.actionEventLogsPath = () => join(ActionLogPath, "action-event-logs");
		_ActionLog.errorRecordsPath = () => join(ActionLogPath, "error-records");
	})(ActionLog || (ActionLog = _RTDBPath.ActionLog || (_RTDBPath.ActionLog = {})));
	let App;
	(function(_App) {
		const AppPath = "levii-balus-app";
		_App.appPath = () => AppPath;
		let Billing;
		(function(_Billing) {
			const BillingPath = join(AppPath, "billing");
			const groupBillingProfilesPath = _Billing.groupBillingProfilesPath = () => join(BillingPath, "group-profiles");
			_Billing.groupBillingProfilePath = (groupId) => join(groupBillingProfilesPath(), groupId);
			const billingRevisionsPath = _Billing.billingRevisionsPath = () => join(BillingPath, "billing-revisions");
			_Billing.billingRevisionPath = (groupId) => join(billingRevisionsPath(), groupId);
			_Billing.stripeIdGroupIndexPath = (stripeId) => join(BillingPath, "stripe-id-group-index", stripeId);
			const stripeEventProcessingsPath = _Billing.stripeEventProcessingsPath = () => join(BillingPath, "stripe-event-processings");
			_Billing.stripeEventProcessingPath = (eventId) => join(stripeEventProcessingsPath(), eventId);
			const operationsPath = _Billing.operationsPath = (groupId) => join(BillingPath, "operations", groupId);
			_Billing.operationPath = (groupId, operationId) => join(operationsPath(groupId), operationId);
		})(Billing || (Billing = _App.Billing || (_App.Billing = {})));
		let ApplicationConfig;
		(function(_ApplicationConfig) {
			const applicationConfigPath = _ApplicationConfig.applicationConfigPath = () => join(AppPath, "application-config");
			_ApplicationConfig.requiredVersionPath = () => join(applicationConfigPath(), "requiredVersion");
			_ApplicationConfig.releaseTogglePath = (toggleName) => join(applicationConfigPath(), "release-toggles", toggleName);
			_ApplicationConfig.maintenanceStartAtPath = () => join(applicationConfigPath(), "maintenanceStartAt");
			const allVersionsPath = _ApplicationConfig.allVersionsPath = () => join(applicationConfigPath(), "versions");
			const versionsPath = _ApplicationConfig.versionsPath = (hostname) => join(allVersionsPath(), hostname.replace(/\./g, "-DOT-"));
			const versionPath = _ApplicationConfig.versionPath = (hostname, version) => join(versionsPath(hostname), `${version}`);
			_ApplicationConfig.versionActivePath = (hostname, version) => join(versionPath(hostname, version), "active");
			_ApplicationConfig.kataWorkspaceIdPath = () => join(applicationConfigPath(), "kata-workspace-id");
			_ApplicationConfig.defaultAIUsageAllocationRatePath = () => join(applicationConfigPath(), "default-ai-usage-allocation-rate");
		})(ApplicationConfig || (ApplicationConfig = _App.ApplicationConfig || (_App.ApplicationConfig = {})));
		let Admin;
		(function(_Admin) {
			const AppAdminPath = join(AppPath, "admin");
			const operatorsPath = _Admin.operatorsPath = () => join(AppAdminPath, "operators");
			_Admin.operatorPath = (operatorId) => join(operatorsPath(), operatorId);
		})(Admin || (Admin = _App.Admin || (_App.Admin = {})));
		let Notification;
		(function(_Notification) {
			const NotificationPath = join(AppPath, "notification");
			const announcementsPath = _Notification.announcementsPath = () => join(NotificationPath, "announcements");
			_Notification.announcementPath = (id) => join(announcementsPath(), id);
			_Notification.announcementLastViewTimePath = (userId) => join(NotificationPath, "announcement-last-viewed-time", userId);
			_Notification.bannerAnnouncementPath = () => join(NotificationPath, "banner-announcement");
		})(Notification || (Notification = _App.Notification || (_App.Notification = {})));
		let User;
		(function(_User) {
			const UserPath = join(AppPath, "user");
			const activeClientSessionsPath = _User.activeClientSessionsPath = () => join(UserPath, "active-client-sessions");
			const activeClientSessionPath = _User.activeClientSessionPath = (clientId) => join(activeClientSessionsPath(), clientId);
			_User.activeClientSessionStartAtPath = (clientId) => join(activeClientSessionPath(clientId), "startAt");
			const activeAuthSessionsPath = _User.activeAuthSessionsPath = () => join(UserPath, "active-auth-sessions");
			const activeAuthSessionPath = _User.activeAuthSessionPath = (sessionId) => join(activeAuthSessionsPath(), sessionId);
			_User.activeAuthSessionCurrentIpPath = (sessionId) => join(activeAuthSessionPath(sessionId), "currentIp");
			const onetimePasswordsPath = _User.onetimePasswordsPath = () => join(UserPath, "one-time-passwords");
			_User.onetimePassword = (temporaryId) => join(onetimePasswordsPath(), temporaryId);
			_User.anonymousUserPath = (userId) => join(UserPath, "anonymous-users", userId);
			_User.userLoginIdentifierPath = (id) => join(UserPath, "login-identifiers", id);
			const userAuthProvidersPath = _User.userAuthProvidersPath = () => join(UserPath, "auth-providers");
			_User.userAuthProviderPath = (userId) => join(userAuthProvidersPath(), userId);
			_User.credentialPath = (userId) => join(UserPath, "credentials", userId);
			_User.publicProfilePath = (userId) => join(UserPath, "public-profiles", userId);
			const userEntitiesPath = _User.userEntitiesPath = () => join(UserPath, "entities");
			_User.userEntityPath = (userId) => join(userEntitiesPath(), userId);
			_User.userSurveyAnswerPath = (userId) => join(UserPath, "survey-answer", userId);
			_User.userOnboardingGuideStoppedPath = (userId) => join(UserPath, "onboarding-guide-stopped", userId);
			const userOnboardingGuideCompletedJobsPath = _User.userOnboardingGuideCompletedJobsPath = () => join(UserPath, "onboarding-guide-completed");
			_User.userOnboardingGuideCompletedJobPath = (jobId) => join(userOnboardingGuideCompletedJobsPath(), jobId);
			const UserPasswordResetTokensPath = join(UserPath, "password-reset-tokens");
			_User.userPasswordResetTokensPath = () => UserPasswordResetTokensPath;
			_User.userPasswordResetTokenPath = (id) => join(UserPasswordResetTokensPath, id);
			const UserMailAddressChangeTokensPath = join(UserPath, "mail-address-change-tokens");
			_User.userMailAddressChangeTokensPath = () => UserMailAddressChangeTokensPath;
			_User.userMailAddressChangeTokenPath = (id) => join(UserMailAddressChangeTokensPath, id);
			const UserSignUpRequestTokensPath = join(UserPath, "signup-request-tokens");
			_User.userSignUpRequestTokensPath = () => UserSignUpRequestTokensPath;
			_User.userSignUpRequestTokenPath = (id) => join(UserSignUpRequestTokensPath, id);
		})(User || (User = _App.User || (_App.User = {})));
		let Group;
		(function(_Group) {
			const GroupInfoPath = join(AppPath, "group");
			const groupEntitiesPath = _Group.groupEntitiesPath = () => join(GroupInfoPath, "entities");
			const groupEntityPath = _Group.groupEntityPath = (groupId) => join(groupEntitiesPath(), groupId);
			_Group.enableIndividualViewModelPermissionsPath = (groupId) => join(groupEntityPath(groupId), "setting", "enableIndividualViewModelPermissions");
			const memberInvitationsPath = _Group.memberInvitationsPath = (groupId) => join(GroupInfoPath, "member-invitations", groupId);
			const multiFactorAuthRequiredAllPath = _Group.multiFactorAuthRequiredAllPath = () => join(GroupInfoPath, "multi-factor-auth-required");
			_Group.multiFactorAuthRequiredPath = (groupId) => join(multiFactorAuthRequiredAllPath(), groupId);
			_Group.memberInvitationPath = (groupId, invitationId) => join(memberInvitationsPath(groupId), invitationId);
			_Group.memberInvitationAcceptPath = (groupId, userId) => join(GroupInfoPath, "member-invitation-accepts", groupId, userId, "invitationId");
			_Group.memberInvitationWorkspacePath = (groupId, userId) => join(GroupInfoPath, "member-invitation-workspaces", groupId, userId, "workspaces");
			const memberRolesPath = _Group.memberRolesPath = (groupId) => join(GroupInfoPath, "member-roles", groupId);
			_Group.memberRolePath = (groupId, userId) => join(memberRolesPath(groupId), userId);
			const settingPath = _Group.settingPath = (groupId) => join(groupEntityPath(groupId), "setting");
			_Group.settingAvailableSignUpMethodsPath = (groupId) => join(settingPath(groupId), "availableSignUpMethods");
			_Group.settingDefaultModelingFormatPath = (groupId) => join(settingPath(groupId), "defaultModelingFormat");
			const internalPublicWorkspacesPath = _Group.internalPublicWorkspacesPath = (groupId) => join(GroupInfoPath, "internal-public-workspaces", groupId);
			_Group.internalPublicWorkspacePath = (groupId, workspaceId) => join(internalPublicWorkspacesPath(groupId), workspaceId);
			const groupLicensesPath = _Group.groupLicensesPath = () => join(GroupInfoPath, "licenses");
			_Group.groupLicensePath = (groupId) => join(groupLicensesPath(), groupId);
			const groupLicenseInternalNotesPath = _Group.groupLicenseInternalNotesPath = () => join(GroupInfoPath, "license-internal-notes");
			_Group.groupLicenseInternalNotePath = (groupId) => join(groupLicenseInternalNotesPath(), groupId);
			const groupLicenseUpdateLogsRootPath = () => join(GroupInfoPath, "license-update-logs");
			const groupLicenseUpdateLogsPath = _Group.groupLicenseUpdateLogsPath = (groupId) => join(groupLicenseUpdateLogsRootPath(), groupId);
			_Group.groupLicenseUpdateLogPath = (groupId, logId) => join(groupLicenseUpdateLogsPath(groupId), logId);
			const groupLicenseNotificationCompletedJobsPath = _Group.groupLicenseNotificationCompletedJobsPath = () => join(GroupInfoPath, "license-notifications-completed");
			_Group.groupLicenseNotificationCompletedJobPath = (jobId) => join(groupLicenseNotificationCompletedJobsPath(), jobId);
			_Group.groupBookmarkViewModelsPath = (groupId, userId) => join(GroupInfoPath, "bookmark-view-models", groupId, userId);
			const assignedGroupIndexPath = _Group.assignedGroupIndexPath = (userId) => join(GroupInfoPath, "assigned-group-index", userId);
			_Group.assignedGroupIndexValuePath = (userId, groupId) => join(assignedGroupIndexPath(userId), groupId);
			const workspaceIndexPath = _Group.workspaceIndexPath = (groupId) => join(GroupInfoPath, "workspace-index", groupId);
			_Group.workspaceIndexValuePath = (groupId, workspaceId) => join(workspaceIndexPath(groupId), workspaceId);
			const assignedWorkspaceIdGroupGuestsPath = _Group.assignedWorkspaceIdGroupGuestsPath = (groupId) => join(GroupInfoPath, "assigned-workspace-id-group-guest", groupId);
			_Group.assignedWorkspaceIdGroupGuestPath = (groupId, userId) => join(assignedWorkspaceIdGroupGuestsPath(groupId), userId);
			_Group.groupConsoleUsingPath = (sessionId) => join(GroupInfoPath, "group-console-using", sessionId);
			const ipRestrictionPath = _Group.ipRestrictionPath = (groupId) => join(GroupInfoPath, "ip-restrictions", groupId);
			_Group.ipRestrictionConfigurationPath = (groupId) => join(ipRestrictionPath(groupId), "configuration");
			_Group.ipRestrictionEnabledPath = (groupId) => join(ipRestrictionPath(groupId), "enabled");
			const aiAssistantPath = _Group.aiAssistantPath = (groupId) => join(GroupInfoPath, "ai-assistant", groupId);
			_Group.aiAssistantEnabledPath = (groupId) => join(aiAssistantPath(groupId), "enabled");
			const aiAssistantMemberEnabledEntriesPath = _Group.aiAssistantMemberEnabledEntriesPath = (groupId) => join(aiAssistantPath(groupId), "member-enabled");
			_Group.aiAssistantMemberEnabledPath = (groupId, userId) => join(aiAssistantMemberEnabledEntriesPath(groupId), userId);
			_Group.aiUsageAllocationRatePath = (groupId) => join(aiAssistantPath(groupId), "usage-allocation-rate");
			const aiUsageMonthlyEntriesPath = _Group.aiUsageMonthlyEntriesPath = (groupId, monthKey) => join(aiAssistantPath(groupId), "usage", monthKey);
			_Group.aiUsageMemberMonthlyPath = (groupId, monthKey, userId) => join(aiUsageMonthlyEntriesPath(groupId, monthKey), userId);
		})(Group || (Group = _App.Group || (_App.Group = {})));
		let Mail;
		(function(_Mail) {
			const MailPath = join(AppPath, "mail");
			const groupInvitationMailDataPath = _Mail.groupInvitationMailDataPath = (groupId) => join(MailPath, "group", groupId, "invitation-mail-data");
			_Mail.groupInvitationMailDataSendPath = (groupId, mailDataId) => join(groupInvitationMailDataPath(groupId), mailDataId, "send");
		})(Mail || (Mail = _App.Mail || (_App.Mail = {})));
		let Workspace;
		(function(_Workspace) {
			const WorkspaceInfoPath = join(AppPath, "workspace");
			const workspaceEntityPath = _Workspace.workspaceEntityPath = (workspaceId) => join(WorkspaceInfoPath, "entities", workspaceId);
			_Workspace.assignedGroupWorkspaceIndexAncestorPath = (userId) => join(WorkspaceInfoPath, "assigned-group-workspace-index", userId);
			_Workspace.workspaceGroupIdPath = (workspaceId) => join(workspaceEntityPath(workspaceId), "groupId");
			const settingPath = _Workspace.settingPath = (workspaceId) => join(workspaceEntityPath(workspaceId), "setting");
			_Workspace.settingIsPublicSpacePath = (workspaceId) => join(settingPath(workspaceId), "isPublicSpace");
			_Workspace.settingIsViewModelURLShareablePath = (workspaceId) => join(settingPath(workspaceId), "isViewModelURLShareable");
			_Workspace.settingModelingFormatPath = (workspaceId) => join(settingPath(workspaceId), "modelingFormat");
			const memberRolesPath = _Workspace.memberRolesPath = (workspaceId) => join(WorkspaceInfoPath, "member-roles", workspaceId);
			_Workspace.memberRolePath = (workspaceId, userId) => join(memberRolesPath(workspaceId), userId);
			_Workspace.rootFolderTreePath = (workspaceId) => join(WorkspaceInfoPath, "root-folder-trees", workspaceId);
			_Workspace.folderPath = (folderId) => join(WorkspaceInfoPath, "folders", folderId);
			const assignedGroupWorkspaceIndexPath = _Workspace.assignedGroupWorkspaceIndexPath = (userId, groupId) => join(WorkspaceInfoPath, "assigned-group-workspace-index", userId, groupId);
			_Workspace.assignedGroupWorkspaceIndexValuePath = (userId, groupId, workspaceId) => join(assignedGroupWorkspaceIndexPath(userId, groupId), workspaceId);
		})(Workspace || (Workspace = _App.Workspace || (_App.Workspace = {})));
		let ViewModel;
		(function(_ViewModel) {
			const ViewModelNamespace = join(AppPath, "view-model");
			const viewModelsPath = _ViewModel.viewModelsPath = () => join(ViewModelNamespace, "entities");
			const viewModelPath = _ViewModel.viewModelPath = (viewModelId) => join(viewModelsPath(), viewModelId);
			_ViewModel.viewModelAssetPath = (viewModelId, assetId) => join(ViewModelNamespace, "contents", viewModelId, "assets", assetId);
			const viewModelContentPath = _ViewModel.viewModelContentPath = (viewModelId) => join(ViewModelNamespace, "contents", viewModelId);
			_ViewModel.updatedAtPath = (viewModelId) => join(viewModelPath(viewModelId), "updatedAt");
			_ViewModel.trashedAtPath = (viewModelId) => join(viewModelPath(viewModelId), "trashedAt");
			_ViewModel.sharingUserRolePath = (viewModelId) => join(viewModelPath(viewModelId), "sharingUserRole");
			_ViewModel.viewModelWorkspaceIdPath = (viewModelId) => join(viewModelPath(viewModelId), "workspaceId");
			_ViewModel.viewModelGroupIdPath = (viewModelId) => join(viewModelPath(viewModelId), "groupId");
			const individualPermissionsPath = _ViewModel.individualPermissionsPath = (viewModelId) => join(ViewModelNamespace, "individual-permissions", viewModelId);
			_ViewModel.individualPermissionPath = (viewModelId, userId) => join(individualPermissionsPath(viewModelId), userId);
			_ViewModel.timerPath = (viewModelId) => join(ViewModelNamespace, "timer", viewModelId);
			const aiAssistantSkillsPath = _ViewModel.aiAssistantSkillsPath = (viewModelId) => join(ViewModelNamespace, "ai-assistant-skills", viewModelId);
			_ViewModel.aiAssistantSkillPath = (viewModelId, skillId) => join(aiAssistantSkillsPath(viewModelId), skillId);
			const PrivateAIAssistantChatsPath = join(ViewModelNamespace, "private-ai-assistant-chats");
			const privateAIAssistantChatThreadsPath = _ViewModel.privateAIAssistantChatThreadsPath = (viewModelId, userId) => join(PrivateAIAssistantChatsPath, "threads", viewModelId, userId);
			_ViewModel.privateAIAssistantChatThreadPath = (viewModelId, userId, threadId) => join(privateAIAssistantChatThreadsPath(viewModelId, userId), threadId);
			_ViewModel.privateAIAssistantChatMessagesPath = (viewModelId, userId, threadId) => join(PrivateAIAssistantChatsPath, "messages", viewModelId, userId, threadId);
			let ConsistencyLink;
			(function(_ConsistencyLink) {
				const linksPath = _ConsistencyLink.linksPath = (viewModelId) => join(viewModelContentPath(viewModelId), "consistency-links");
				_ConsistencyLink.linkPath = (viewModelId, consistencyLinkId) => join(linksPath(viewModelId), consistencyLinkId);
			})(ConsistencyLink || (ConsistencyLink = _ViewModel.ConsistencyLink || (_ViewModel.ConsistencyLink = {})));
			let View;
			(function(_View) {
				const viewsPath = _View.viewsPath = (viewModelId) => join(viewModelContentPath(viewModelId), "views");
				const viewPath = _View.viewPath = (viewModelId, viewId) => join(viewsPath(viewModelId), viewId);
				_View.namePath = (viewModelId, viewId) => join(viewPath(viewModelId, viewId), "name");
				_View.sizePath = (viewModelId, viewId) => join(viewPath(viewModelId, viewId), "size");
				_View.settingPath = (viewModelId, viewId) => join(viewPath(viewModelId, viewId), "setting");
				_View.themeColorPath = (viewModelId, viewId) => join(viewPath(viewModelId, viewId), "themeColor");
				const positionsPath = _View.positionsPath = (viewModelId) => join(viewModelContentPath(viewModelId), "view-positions");
				_View.positionPath = (viewModelId, viewId) => join(positionsPath(viewModelId), viewId);
			})(View || (View = _ViewModel.View || (_ViewModel.View = {})));
			let Model;
			(function(_Model) {
				const modelsPath = _Model.modelsPath = (viewModelId) => join(viewModelContentPath(viewModelId), "models");
				_Model.modelPath = (viewModelId, modelId) => join(modelsPath(viewModelId), modelId);
				const modelContentsPath = (viewModelId) => join(viewModelContentPath(viewModelId), "model-contents");
				const modelContentPath = _Model.modelContentPath = (viewModelId, modelId) => join(modelContentsPath(viewModelId), modelId);
				_Model.displayOrderPath = (viewModelId, modelId) => join(modelContentPath(viewModelId, modelId), "display-order");
				let Comment;
				(function(_Comment) {
					const threadsPath = _Comment.threadsPath = (viewModelId, modelId) => join(modelContentPath(viewModelId, modelId), "model-comment-threads");
					_Comment.threadPath = (viewModelId, modelId, threadId) => join(threadsPath(viewModelId, modelId), threadId);
					_Comment.positionsPath = (viewModelId, modelId) => join(modelContentPath(viewModelId, modelId), "model-comment-positions");
				})(Comment || (Comment = _Model.Comment || (_Model.Comment = {})));
				let Node;
				(function(_Node) {
					const nodesPath = _Node.nodesPath = (viewModelId, modelId) => join(modelContentPath(viewModelId, modelId), "nodes");
					const nodePath = _Node.nodePath = (viewModelId, modelId, nodeId) => join(nodesPath(viewModelId, modelId), nodeId);
					_Node.nodeNamePath = (viewModelId, modelId, nodeId) => join(nodePath(viewModelId, modelId, nodeId), "name");
					_Node.nodeStylePath = (viewModelId, modelId, nodeId) => join(nodePath(viewModelId, modelId, nodeId), "style");
					_Node.nodeUrlPath = (viewModelId, modelId, nodeId) => join(nodePath(viewModelId, modelId, nodeId), "url");
					const descriptionsPath = _Node.descriptionsPath = (viewModelId, modelId) => join(modelContentPath(viewModelId, modelId), "node-descriptions");
					_Node.descriptionPath = (viewModelId, modelId, elementId) => join(descriptionsPath(viewModelId, modelId), elementId);
					const reactionPath = _Node.reactionPath = (viewModelId, modelId, nodeId) => join(reactionsPath(viewModelId, modelId), nodeId);
					const reactionsPath = _Node.reactionsPath = (viewModelId, modelId) => join(modelContentPath(viewModelId, modelId), "node-reactions");
					_Node.reactionItemPath = (viewModelId, modelId, nodeId, reactionType, userId) => join(reactionPath(viewModelId, modelId, nodeId), reactionType, userId);
				})(Node || (Node = _Model.Node || (_Model.Node = {})));
				let Link;
				(function(_Link) {
					const linksPath = _Link.linksPath = (viewModelId, modelId) => join(modelContentPath(viewModelId, modelId), "links");
					_Link.linkPath = (viewModelId, modelId, linkId) => join(linksPath(viewModelId, modelId), linkId);
				})(Link || (Link = _Model.Link || (_Model.Link = {})));
				let AnnotationLink;
				(function(_AnnotationLink) {
					const linksPath = _AnnotationLink.linksPath = (viewModelId, modelId) => join(modelContentPath(viewModelId, modelId), "annotation-links");
					_AnnotationLink.linkPath = (viewModelId, modelId, linkId) => join(linksPath(viewModelId, modelId), linkId);
				})(AnnotationLink || (AnnotationLink = _Model.AnnotationLink || (_Model.AnnotationLink = {})));
				let Zone;
				(function(_Zone) {
					const zonesPath = _Zone.zonesPath = (viewModelId, modelId) => join(modelContentPath(viewModelId, modelId), "sticky-zones");
					const zonePath = _Zone.zonePath = (viewModelId, modelId, zoneKeyString) => join(zonesPath(viewModelId, modelId), zoneKeyString);
					_Zone.zoneTextPath = (viewModelId, modelId, zoneKeyString) => join(zonePath(viewModelId, modelId, zoneKeyString), "text");
					_Zone.zoneUrlPath = (viewModelId, modelId, zoneKeyString) => join(zonePath(viewModelId, modelId, zoneKeyString), "url");
					_Zone.sizePath = (viewModelId, modelId, zoneKeyString) => join(zonePath(viewModelId, modelId, zoneKeyString), "size");
					const positionsPath = _Zone.positionsPath = (viewModelId, modelId) => join(modelContentPath(viewModelId, modelId), "zone-positions");
					_Zone.positionPath = (viewModelId, modelId, zoneId) => join(positionsPath(viewModelId, modelId), zoneId);
					const descriptionsPath = _Zone.descriptionsPath = (viewModelId, modelId) => join(modelContentPath(viewModelId, modelId), "zone-descriptions");
					_Zone.descriptionPath = (viewModelId, modelId, elementId) => join(descriptionsPath(viewModelId, modelId), elementId);
				})(Zone || (Zone = _Model.Zone || (_Model.Zone = {})));
				let DescriptionPanel;
				(function(_DescriptionPanel) {
					const panelsPath = _DescriptionPanel.panelsPath = (viewModelId, modelId) => join(modelContentPath(viewModelId, modelId), "description-panels");
					const panelPath = _DescriptionPanel.panelPath = (viewModelId, modelId, panelId) => join(panelsPath(viewModelId, modelId), panelId);
					_DescriptionPanel.descriptionPath = (viewModelId, modelId, panelId) => join(panelPath(viewModelId, modelId, panelId), "description");
					_DescriptionPanel.htmlDescriptionPath = (viewModelId, modelId, panelId) => join(panelPath(viewModelId, modelId, panelId), "htmlDescription");
					_DescriptionPanel.fontSizePath = (viewModelId, modelId, panelId) => join(panelPath(viewModelId, modelId, panelId), "fontSize");
					_DescriptionPanel.sizePath = (viewModelId, modelId, panelId) => join(panelPath(viewModelId, modelId, panelId), "size");
					const positionsPath = _DescriptionPanel.positionsPath = (viewModelId, modelId) => join(modelContentPath(viewModelId, modelId), "description-panel-positions");
					_DescriptionPanel.positionPath = (viewModelId, modelId, panelId) => join(positionsPath(viewModelId, modelId), panelId);
				})(DescriptionPanel || (DescriptionPanel = _Model.DescriptionPanel || (_Model.DescriptionPanel = {})));
				let FileContainer;
				(function(_FileContainer) {
					const containersPath = _FileContainer.containersPath = (viewModelId, modelId) => join(modelContentPath(viewModelId, modelId), "file-containers");
					const containerPath = _FileContainer.containerPath = (viewModelId, modelId, fileContainerId) => join(containersPath(viewModelId, modelId), fileContainerId);
					_FileContainer.sizePath = (viewModelId, modelId, fileContainerId) => join(containerPath(viewModelId, modelId, fileContainerId), "size");
					const positionsPath = _FileContainer.positionsPath = (viewModelId, modelId) => join(modelContentPath(viewModelId, modelId), "file-container-positions");
					_FileContainer.positionPath = (viewModelId, modelId, fileContainerId) => join(positionsPath(viewModelId, modelId), fileContainerId);
				})(FileContainer || (FileContainer = _Model.FileContainer || (_Model.FileContainer = {})));
			})(Model || (Model = _ViewModel.Model || (_ViewModel.Model = {})));
			let Asset;
			(function(_Asset) {
				const assetsPath = _Asset.assetsPath = (viewModelId) => join(viewModelContentPath(viewModelId), "assets");
				_Asset.assetPath = (viewModelId, assetId) => join(assetsPath(viewModelId), assetId);
			})(Asset || (Asset = _ViewModel.Asset || (_ViewModel.Asset = {})));
			let ViewModelViewer;
			(function(_ViewModelViewer) {
				const viewModelViewerContentPath = (viewModelId) => join(ViewModelNamespace, "viewer-contents", viewModelId);
				const viewersPath = _ViewModelViewer.viewersPath = (viewModelId) => join(viewModelViewerContentPath(viewModelId), "viewers");
				_ViewModelViewer.viewerPath = (viewModelId, clientId) => join(viewersPath(viewModelId), clientId);
				const editingUsersPath = _ViewModelViewer.editingUsersPath = (viewModelId) => join(viewModelViewerContentPath(viewModelId), "editing-user");
				_ViewModelViewer.editingUserPath = (viewModelId, urlSafeKeyString) => join(editingUsersPath(viewModelId), urlSafeKeyString);
				const clientMouseCursorsPath = _ViewModelViewer.clientMouseCursorsPath = (viewModelId) => join(viewModelViewerContentPath(viewModelId), "client-mouse-cursors");
				_ViewModelViewer.clientMouseCursorPath = (viewModelId, clientId) => join(clientMouseCursorsPath(viewModelId), clientId);
				const clientSelectedItemsPath = (viewModelId) => join(viewModelViewerContentPath(viewModelId), "client-selected-items");
				_ViewModelViewer.clientSelectedItemPath = (viewModelId, modelId) => join(clientSelectedItemsPath(viewModelId), modelId);
				_ViewModelViewer.huddlePath = (viewModelId) => join(viewModelViewerContentPath(viewModelId), "huddle");
			})(ViewModelViewer || (ViewModelViewer = _ViewModel.ViewModelViewer || (_ViewModel.ViewModelViewer = {})));
			_ViewModel.userOperationModePath = (userId) => join(ViewModelNamespace, "user-operation-modes", userId);
			let Tags;
			(function(_Tags) {
				const tagsPath = _Tags.tagsPath = (groupId) => join(ViewModelNamespace, "tags", groupId);
				const tagsEntitiesPath = _Tags.tagsEntitiesPath = (groupId) => join(tagsPath(groupId), "entities");
				_Tags.tagsEntityPath = (groupId, tagId) => join(tagsEntitiesPath(groupId), tagId);
				const tagsUniqueIndexesPath = _Tags.tagsUniqueIndexesPath = (groupId) => join(tagsPath(groupId), "unique-indexes");
				_Tags.tagsUniqueIndexPath = (groupId, hashedName) => join(tagsUniqueIndexesPath(groupId), hashedName);
				const tagsAssignedViewModelsGroupPath = _Tags.tagsAssignedViewModelsGroupPath = (groupId) => join(tagsPath(groupId), "assigned-view-models");
				const tagsAssignedViewModelsPath = _Tags.tagsAssignedViewModelsPath = (groupId, tagId) => join(tagsAssignedViewModelsGroupPath(groupId), tagId);
				_Tags.tagsAssignedViewModelPath = (groupId, tagId, viewModelId) => join(tagsAssignedViewModelsPath(groupId, tagId), viewModelId);
			})(Tags || (Tags = _ViewModel.Tags || (_ViewModel.Tags = {})));
		})(ViewModel || (ViewModel = _App.ViewModel || (_App.ViewModel = {})));
		let AccessControl;
		(function(_AccessControl) {
			const AccessControlPath = join(AppPath, "access-control");
			const groupIpRestrictionCheckRequestsPath = _AccessControl.groupIpRestrictionCheckRequestsPath = () => join(AccessControlPath, "group-ip-restriction-check-requests");
			const groupIpRestrictionCheckRequestPath = _AccessControl.groupIpRestrictionCheckRequestPath = (groupId, sessionId, clientId) => join(groupIpRestrictionCheckRequestsPath(), `${groupId}---${sessionId || "null"}---${clientId}`);
			_AccessControl.groupIpRestrictionCheckRequestStatusPath = (groupId, sessionId, clientId) => join(groupIpRestrictionCheckRequestPath(groupId, sessionId, clientId), "status");
			const groupIpRestrictionCheckRequestPathRaw = _AccessControl.groupIpRestrictionCheckRequestPathRaw = (id) => join(groupIpRestrictionCheckRequestsPath(), id);
			_AccessControl.groupIpRestrictionCheckRequestStatusPathRaw = (id) => join(groupIpRestrictionCheckRequestPathRaw(id), "status");
			_AccessControl.groupIpRestrictionCheckRequestUpdatedAtPathRaw = (id) => join(groupIpRestrictionCheckRequestPathRaw(id), "updatedAt");
			const groupIpRestrictionAllAllowSessionsPath = _AccessControl.groupIpRestrictionAllAllowSessionsPath = () => join(AccessControlPath, "group-ip-restriction-allow-sessions");
			const groupIpRestrictionAllowSessionsPath = _AccessControl.groupIpRestrictionAllowSessionsPath = (sessionId) => join(groupIpRestrictionAllAllowSessionsPath(), sessionId);
			_AccessControl.groupIpRestrictionAllowSessionPath = (sessionId, groupId) => join(groupIpRestrictionAllowSessionsPath(sessionId), groupId);
		})(AccessControl || (AccessControl = _App.AccessControl || (_App.AccessControl = {})));
	})(App || (App = _RTDBPath.App || (_RTDBPath.App = {})));
	_RTDBPath.AccessControl = App.AccessControl;
	_RTDBPath.Admin = App.Admin;
	_RTDBPath.ApplicationConfig = App.ApplicationConfig;
	_RTDBPath.Billing = App.Billing;
	_RTDBPath.Notification = App.Notification;
	_RTDBPath.Group = App.Group;
	_RTDBPath.Mail = App.Mail;
	_RTDBPath.User = App.User;
	_RTDBPath.Workspace = App.Workspace;
	_RTDBPath.ViewModel = App.ViewModel;
	_RTDBPath.ViewModelViewer = App.ViewModel.ViewModelViewer;
	_RTDBPath.ConsistencyLink = App.ViewModel.ConsistencyLink;
	_RTDBPath.Model = App.ViewModel.Model;
	_RTDBPath.View = App.ViewModel.View;
	_RTDBPath.Comment = App.ViewModel.Model.Comment;
	_RTDBPath.DescriptionPanel = App.ViewModel.Model.DescriptionPanel;
	_RTDBPath.FileContainer = App.ViewModel.Model.FileContainer;
	_RTDBPath.Node = App.ViewModel.Model.Node;
	_RTDBPath.Link = App.ViewModel.Model.Link;
	_RTDBPath.AnnotationLink = App.ViewModel.Model.AnnotationLink;
	_RTDBPath.Zone = App.ViewModel.Model.Zone;
	_RTDBPath.ViewModelTags = App.ViewModel.Tags;
})(RTDBPath || (RTDBPath = {}));
//#endregion
//#region src/schema/__action-log__/action-event-logs/ActionEventLogJSON.ts
const ActionLogEventDefinitions = {
	"appengine:editUserProfile": {
		description: "自分自身のプロフィールを編集した",
		event_source: "appengine"
	},
	"appengine:sidebarSearch:search": {
		description: "サイドバーのキーワード検索機能を利用した",
		event_source: "appengine"
	},
	"appengine:test": {
		description: "AppEngineのイベントテスト用",
		event_source: "appengine"
	},
	"appengine:user:auth:authCallback": {
		description: "ユーザーがOAuth認証URLのコールバックを行った時。",
		event_source: "appengine"
	},
	"appengine:user:auth:connectJiji": {
		description: "ユーザーがJijiアカウントと関連づけを行った時。",
		event_source: "appengine"
	},
	"appengine:user:auth:disconnectJiji": {
		description: "ユーザーがJijiアカウントと関連づけ解除を行った時。",
		event_source: "appengine"
	},
	"appengine:user:auth:disconnectGoogle": {
		description: "ユーザーがGoogleアカウントとの連携解除(Firebase Auth ベース)を行った時。",
		event_source: "appengine"
	},
	"appengine:user:auth:disconnectMicrosoft": {
		description: "ユーザーがMicrosoftアカウントとの連携解除(Firebase Auth ベース)を行った時。",
		event_source: "appengine"
	},
	"appengine:user:auth:verifyGoogleLink": {
		description: "ユーザーがGoogleアカウント連携(Firebase Auth の linkWithRedirect)後の検証を行った時。",
		event_source: "appengine"
	},
	"appengine:user:auth:verifyMicrosoftLink": {
		description: "ユーザーがMicrosoftアカウント連携(Firebase Auth の linkWithRedirect)後の検証を行った時。",
		event_source: "appengine"
	},
	"appengine:user:auth:getAuthorizationUrl": {
		description: "ユーザーがOAuth認証URLを取得した時。",
		event_source: "appengine"
	},
	"appengine:user:auth:loginWithPassword": {
		description: "メールアドレスとパスワードを利用してログインする",
		event_source: "appengine"
	},
	"appengine:user:auth:oneTimePasswordVerification": {
		description: "ユーザーがワンタイムパスワードを検証した時。",
		event_source: "appengine"
	},
	"appengine:user:auth:sendPasswordResetToken": {
		description: "パスワード再設定トークンを作成してメールで送付する",
		event_source: "appengine"
	},
	"appengine:user:auth:fetchPasswordResetToken": {
		description: "パスワード再設定トークンが有効か検証する",
		event_source: "appengine"
	},
	"appengine:user:auth:fetchSignUpUserData": {
		description: "ユーザーが新規登録情報を取得した時。",
		event_source: "appengine"
	},
	"appengine:user:auth:fetchSignUpRequestToken": {
		description: "ユーザ登録の本人確認用メールに含まれるサインアップ・トークンを元にサインアップ情報を取得した",
		event_source: "appengine"
	},
	"appengine:user:auth:resetPasswordAndLogin": {
		description: "パスワード再設定トークンを利用してパスワードを再設定し、ログイン用のカスタムトークンを得る",
		event_source: "appengine"
	},
	"appengine:user:auth:signupPasswordAuth": {
		description: "ユーザーがパスワード認証で新規登録した時。",
		event_source: "appengine"
	},
	"appengine:user:auth:sendSignUpRequestToken": {
		description: "ユーザ登録の本人確認用メールを送信した",
		event_source: "appengine"
	},
	"appengine:user:auth:signUp": {
		description: "ユーザーが新規登録した時。",
		event_source: "appengine"
	},
	"appengine:user:auth:deleteUser": {
		description: "オペレータがユーザを削除した時。",
		event_source: "appengine"
	},
	"appengine:user:anonymousUserSignIn": {
		description: "匿名ユーザとしてログインした",
		event_source: "appengine"
	},
	"appengine:user:anonymousUserChangeName": {
		description: "匿名ユーザの名前を変更した",
		event_source: "appengine"
	},
	"appengine:user:auth:createPassword": {
		description: "ユーザが新しくパスワードを設定した",
		event_source: "appengine"
	},
	"appengine:user:auth:changePassword": {
		description: "ユーザがパスワードを更新した",
		event_source: "appengine"
	},
	"appengine:user:auth:changeMailAddress": {
		description: "オペレータがユーザのメールアドレスを変更した時。",
		event_source: "appengine"
	},
	"appengine:user:auth:cancelPendingMailAddressChange": {
		description: "ユーザ自身がメールアドレス変更の申請中表示をキャンセルした時。",
		event_source: "appengine"
	},
	"appengine:viewModel:individualMember:addMembers": {
		description: "ビューモデル個別権限設定のメンバーを追加した",
		event_source: "appengine"
	},
	"appengine:viewModel:individualMember:listIndividualPermittedViewModels": {
		description: "ビューモデル個別権限設定の設定付与状況を取得した",
		event_source: "appengine"
	},
	"appengine:viewModel:individualMember:removeMembers": {
		description: "ビューモデル個別権限設定のメンバーを削除した",
		event_source: "appengine"
	},
	"appengine:viewModel:individualMember:updateMember": {
		description: "ビューモデル個別権限設定のメンバー権限を変更した",
		event_source: "appengine"
	},
	"appengine:viewModel:updateViewModelSettings": {
		description: "ビューモデルの基本設定（名前・共有設定・ロック状態）を更新した",
		event_source: "appengine"
	},
	"appengine:viewModel:uploadFileAsset": {
		description: "ファイルコンテナのファイルをサーバー経由でアップロードした",
		event_source: "appengine"
	},
	"appengine:viewModel:moveAssetToTrash": {
		description: "ファイルコンテナのファイルをゴミ箱に移した",
		event_source: "appengine"
	},
	"appengine:viewModel:restoreAssetFromTrash": {
		description: "ファイルコンテナのファイルをゴミ箱から復元した",
		event_source: "appengine"
	},
	"appengine:viewModel:copyFileAssets": {
		description: "ファイルコンテナのファイルをサーバー側で複製した",
		event_source: "appengine"
	},
	"appengine:viewModelAssetProxy": {
		description: "アセットプロキシのアクセスログ。",
		event_source: "appengine"
	},
	"appengine:aiChatImageProxy": {
		description: "AIアシスタントのチャット添付画像プロキシのアクセスログ。",
		event_source: "appengine"
	},
	"appengine:aiChatFileProxy": {
		description: "AIアシスタントのチャット添付ファイル（スプレッドシート）プロキシのアクセスログ。",
		event_source: "appengine"
	},
	"appengine:aiChatTextFileProxy": {
		description: "AIアシスタントのチャット添付ファイル（テキストファイル）プロキシのアクセスログ。",
		event_source: "appengine"
	},
	"appengine:workspace:addMembers": {
		description: "ワークスペースにメンバーを追加した",
		event_source: "appengine"
	},
	"appengine:workspace:updateWorkspaceEntity": {
		description: "ワークスペース管理者がワークスペースの基本情報（名前・説明・アイコン・モデリングフォーマット）を変更した",
		event_source: "appengine"
	},
	"appengine:workspace:updateWorkspaceShareSetting": {
		description: "ワークスペース管理者がワークスペースの共有設定（グループ内公開・外部公開・個別権限設定等）を変更した",
		event_source: "appengine"
	},
	"appengine:file-uploader:uploadIcon": {
		description: "アイコンをアップロードした時。",
		event_source: "appengine"
	},
	"appengine:aiAssistant:chat": {
		description: "AIアシスタントとのチャットを1リクエスト処理した（トークン使用量を含む）",
		event_source: "appengine"
	},
	"appengine:aiAssistant:fetchUrl": {
		description: "AIアシスタントの fetchUrl ツールがWebページを取得した（署名付きURL等の機密を含みうるため、記録するのはホスト名と結果のみ）",
		event_source: "appengine"
	},
	"appengine:aiAssistant:readViewModel": {
		description: "AIアシスタントが他のビューモデルの内容を読み込んだ（読み込めなかった場合も理由とともに記録する）",
		event_source: "appengine"
	},
	"appengine:aiAssistant:searchViewModels": {
		description: "AIアシスタントが過去のビューモデルを検索した（顧客情報を含みうるため、クエリは本文ではなく長さのみ記録する）",
		event_source: "appengine"
	},
	"appengine:group:updateAIAssistantMemberEnabled": {
		description: "グループ管理者がメンバーごとのAIアシスタント利用可否を変更した",
		event_source: "appengine"
	},
	"appengine:group:updateGroupSettings": {
		description: "グループ管理者がグループの基本設定（名前・アイコン・サインアップ方法・モデリングフォーマット等）を変更した",
		event_source: "appengine"
	},
	"appengine:group:updateIpRestrictionConfiguration": {
		description: "グループ管理者がIPアドレス制限の設定（ポリシー・許可ルール）を変更した",
		event_source: "appengine"
	},
	"appengine:admin:updateIpRestrictionConfiguration": {
		description: "Balus管理者がIPアドレス制限の設定（ポリシー・許可ルール）を変更した",
		event_source: "appengine"
	},
	"appengine:admin:updateGroupLicense": {
		description: "Balus管理者がグループのライセンス情報を更新した",
		event_source: "appengine"
	},
	"appengine:admin:updateIpRestrictionEnabled": {
		description: "Balus管理者がグループのIPアドレス制限の有効/無効を切り替えた",
		event_source: "appengine"
	},
	"appengine:admin:updateMultiFactorAuthRequired": {
		description: "Balus管理者がグループの多要素認証必須設定を切り替えた",
		event_source: "appengine"
	},
	"appengine:admin:updateAIAssistantEnabled": {
		description: "Balus管理者がグループのAIアシスタント有効/無効を切り替えた",
		event_source: "appengine"
	},
	"appengine:admin:bulkCreateUser": {
		description: "Balus管理者がキャパシティ計測用にユーザをバルク作成した（1ユーザごとに記録）",
		event_source: "appengine"
	},
	"appengine:admin:updateAIUsageAllocationRate": {
		description: "Balus管理者がグループのAI利用量の充当率を変更した",
		event_source: "appengine"
	},
	"functions:admin:operatorSignIn": {
		description: "オペレータがログインした時。",
		event_source: "functions"
	},
	"functions:file-uploader:uploadIcon": {
		description: "アイコンをアップロードした時。",
		event_source: "functions"
	},
	"functions:https-app:asset-proxy:accessLog": {
		description: "アセットプロキシのアクセスログ。",
		event_source: "functions"
	},
	"functions:https-app:asset-proxy:viewModelAssetProxy": {
		description: "ビューモデルのアセットプロキシでのイベント",
		event_source: "functions"
	},
	"functions:https-app:free-trial:accessLog": {
		description: "フリートライアル・アプリのアクセスログ。",
		event_source: "functions"
	},
	"functions:https-app:free-trial:startFreeTrial": {
		description: "フリートライアル・アプリの開始イベント。",
		event_source: "functions"
	},
	"functions:user:loginWithPassword": {
		description: "ユーザーがパスワードでログインした時。",
		event_source: "functions"
	},
	"functions:user:getAuthorizationUrl": {
		description: "ユーザーがOAuth認証URLを取得した時。",
		event_source: "functions"
	},
	"functions:user:authCallback": {
		description: "ユーザーがOAuth認証URLのコールバックを行った時。",
		event_source: "functions"
	},
	"functions:user:anonymousUserSignIn": {
		description: "ユーザーが匿名ユーザーとしてログインした時。",
		event_source: "functions"
	},
	"functions:user:anonymousUserChangeName": {
		description: "匿名ユーザーが名前を変更した時。",
		event_source: "functions"
	},
	"functions:user:connectJiji": {
		description: "ユーザーがJijiアカウントと関連づけを行った時。",
		event_source: "functions"
	},
	"functions:user:disconnectJiji": {
		description: "ユーザーがJijiアカウントとの関連づけを解除した時。",
		event_source: "functions"
	},
	"functions:user:userSignUp": {
		description: "ユーザーが新規登録した時。",
		event_source: "functions"
	},
	"functions:user:fetchSignUpUserData": {
		description: "ユーザーが新規登録情報を取得した時。",
		event_source: "functions"
	},
	"functions:user:editUserProfile": {
		description: "ユーザーが自分のプロフィールを編集した時。",
		event_source: "functions"
	},
	"functions:user:createPassword": {
		description: "ユーザーがパスワードを作成した時。",
		event_source: "functions"
	},
	"functions:user:changePassword": {
		description: "ユーザーがパスワードを変更した時。",
		event_source: "functions"
	},
	"functions:user:sendPasswordResetToken": {
		description: "ユーザーがパスワードリセットトークンを送信した時。",
		event_source: "functions"
	},
	"functions:user:fetchPasswordResetToken": {
		description: "ユーザーがパスワードリセットトークンを取得した時。",
		event_source: "functions"
	},
	"functions:user:resetPasswordAndLogin": {
		description: "ユーザーがパスワードをリセットしてログインした時。",
		event_source: "functions"
	},
	"functions:user:changeMailAddress": {
		description: "オペレータがユーザのメールアドレスを変更した時。",
		event_source: "functions"
	},
	"functions:user:requestMailAddressChange": {
		description: "ユーザ自身がメールアドレス変更を申請し、確認メールを送信した時。",
		event_source: "functions"
	},
	"functions:user:confirmMailAddressChange": {
		description: "ユーザ自身によるメールアドレス変更の確認トークンが確定され、RTDBとFirebase Authのメールアドレスが更新された時。",
		event_source: "functions"
	},
	"functions:user:fetchMailAddressChangeToken": {
		description: "メールアドレス変更の確認トークンの状態を取得した時。",
		event_source: "functions"
	},
	"functions:user:deleteUser": {
		description: "オペレータがユーザを削除した時。",
		event_source: "functions"
	},
	"functions:user:signUpPasswordAuth": {
		description: "ユーザーがパスワード認証で新規登録した時。",
		event_source: "functions"
	},
	"functions:user:oneTimePasswordVerification": {
		description: "ユーザーがワンタイムパスワードを検証した時。",
		event_source: "functions"
	},
	"functions:user:reAuthenticate": {
		description: "再認証用のカスタムトークンを発行した",
		event_source: "functions"
	},
	"functions:user:sendSignUpRequestToken": {
		description: "ユーザ登録の本人確認用メールを送信した",
		event_source: "functions"
	},
	"functions:user:fetchSignUpRequestToken": {
		description: "ユーザ登録の本人確認用メールに含まれるサインアップ・トークンを元にサインアップ情報を取得した",
		event_source: "functions"
	},
	"functions:auth-session:created": {
		description: "認証セッションが作成された時。",
		event_source: "functions"
	},
	"functions:auth-session:updated": {
		description: "認証セッションが更新された時。(接続元IPアドレスが更新された場合など)",
		event_source: "functions"
	},
	"functions:auth-session:deleted": {
		description: "認証セッションが削除された時。",
		event_source: "functions"
	},
	"global:page_view": {
		description: "Balusアプリの全てのページ遷移を記録する。eventParams に pageName, workspaceId, viewModelId などの情報は設定されない。",
		event_source: "frontend"
	},
	"global:page_landing": {
		description: "Balusアプリの特定ページの表示時点のイベント。 pageName, workspaceId などの情報が設定される。",
		event_source: "frontend"
	},
	"global:page_leaving": {
		description: "global:landing と対になるページ離脱時のイベント。 pageName, workspaceId などの情報が設定される。",
		event_source: "frontend"
	},
	"global:reload": {
		description: "Balusアプリの再読み込みを行った際に記録する。",
		event_source: "frontend"
	},
	"global:show_reload_modal": {
		description: "Balusアプリの再読み込みを要求するモーダルを表示した際に記録する。",
		event_source: "frontend"
	},
	"global:notification:open": {
		description: "Balus内の通知リストを表示した際に記録する",
		event_source: "frontend"
	},
	"global:notification:announcement:click": {
		description: "Balus内の「お知らせ」通知リンクをクリックした際に記録する",
		event_source: "frontend"
	},
	"global:sidebar:first_loaded": {
		description: "サイドバーの初回ローディング完了時にイベント記録する",
		event_source: "frontend"
	},
	"global:sidebar:search": {
		description: "サイドバーの検索パネルでキーワード検索を実行した時",
		event_source: "frontend"
	},
	"view_model:all_copy": {
		description: "ビューモデル全体のクリップボードへのコピー操作",
		event_source: "frontend"
	},
	"view_model:create": {
		description: "ビューモデル作成した時",
		event_source: "frontend"
	},
	"view_model:create_paste": {
		description: "ビューモデルをクリップボードからの貼り付けによって作成した時",
		event_source: "frontend"
	},
	"view_model:delete": {
		description: "ビューモデルを削除した時",
		event_source: "frontend"
	},
	"view_model:edit": {
		description: "ビューモデルの名前や共有設定などを変更した時",
		event_source: "frontend"
	},
	"view_model:edit_content": {
		description: "ビューモデルの中身を変更した時。ビューの追加・移動や、モデル要素の追加・移動・削除など、何らかの Undo/Redo 可能な操作をおこなった時。",
		event_source: "frontend"
	},
	"view_model:move": {
		description: "ビューモデルのフォルダ階層を移動した時",
		event_source: "frontend"
	},
	"view_model:operation": {
		description: "ビューモデルに対して何らかの操作を行った時。操作の内容は eventParams に operationName として記録される。",
		event_source: "frontend"
	},
	"view_model:restore": {
		description: "ビューモデルをゴミ箱から復元した時。",
		event_source: "frontend"
	},
	"view_model:move_to_other_workspace": {
		description: "ビューモデルを別のワークスペースに移動した時。",
		event_source: "frontend"
	},
	"view_model_folder:create": {
		description: "フォルダを作成した時。",
		event_source: "frontend"
	},
	"view_model_folder:delete": {
		description: "フォルダを削除した時。",
		event_source: "frontend"
	},
	"view_model_folder:edit": {
		description: "フォルダを変更した時。",
		event_source: "frontend"
	},
	"view_model_folder:move": {
		description: "フォルダを移動した時",
		event_source: "frontend"
	},
	"view_model_folder:move_to_other_workspace": {
		description: "フォルダを別のワークスペースに移動した時",
		event_source: "frontend"
	},
	"view_model_folder:duplicate": {
		description: "フォルダを複製した時。",
		event_source: "frontend"
	}
};
//#endregion
//#region src/schema/__common__/timestamp.ts
const timestampISOStringSchema = v.pipe(v.string(), v.isoTimestamp(), v.transform((input) => new Date(Date.parse(input))));
const timestampSchema = v.pipe(v.number(), v.transform((input) => new Date(input)));
//#endregion
//#region src/schema/__app__/admin/operators/{operatorId}/OperatorJSON.ts
const OperatorSchema = v.object({
	id: v.pipe(v.string(), v.nonEmpty()),
	email: v.pipe(v.string(), v.nonEmpty(), v.email(), v.regex(/@levii\.co\.jp$/)),
	createdAt: timestampSchema
});
//#endregion
//#region src/schema/__app__/application-config/ApplicationConfigJSON.ts
/** `default-ai-usage-allocation-rate` もグループ側の上書きも未設定のときに適用される充当率（パーセント）。 */
const DEFAULT_AI_USAGE_ALLOCATION_RATE_PERCENT = 20;
/** 充当率（パーセント）として受け付ける下限。全体設定・グループ上書きで共通。 */
const MIN_AI_USAGE_ALLOCATION_RATE_PERCENT = 0;
/** 全体設定の充当率（パーセント）の上限。全グループの既定値になるため、ライセンス単価を超えさせない。 */
const MAX_GLOBAL_AI_USAGE_ALLOCATION_RATE_PERCENT = 100;
/**
* グループ上書きの充当率（パーセント）の上限。
*
* **暫定の緩和。** AI機能の先行公開にあたり、上限に達して利用できなくなったユーザーを
* そのグループの充当率を上げることで救済する運用のために、全体設定と違って
* ライセンス単価を超える値（100%超）を許している。
* AI機能の正式リリースや新しい料金プランの導入で不要になる可能性がある。
*
* 撤去するときは、この定数を100に戻すだけでは足りない。100%超が保存されたままのグループは
* `resolveAIUsageAllocationRatePercent` が上書きを無効値として読み飛ばし、全体設定の値で
* 動くようになる。管理画面には保存値がそのまま表示されるため、上限額が変わったことに
* 誰も気づけないうえ、不正な値がRTDBに残り続ける。先に
* `group/ai-assistant/{groupId}/usage-allocation-rate` を洗い出し、マイグレーションか
* 管理画面からの入力で100以下に直すか、上書きを削除すること。
*
* 一緒に戻す対象は、この定数と `isValidGroupAIUsageAllocationRatePercent` を grep すれば揃う
* （Bolt の `GroupAIUsageAllocationRatePercent` だけは別途）。
*/
const MAX_GROUP_AI_USAGE_ALLOCATION_RATE_PERCENT = 500;
const isValidAllocationRatePercent = (value, maxPercent) => typeof value === "number" && Number.isFinite(value) && value >= 0 && value <= maxPercent;
/**
* 充当率（パーセント）が範囲内かを判定する。
*
* 範囲の検査は security rules・API入力・RTDB読み取り・入力欄の4層にある。境界値がずれると
* 層ごとに通る値が食い違うため、範囲の出所は MIN/MAX 定数に一本化している。
* 判定が要る層（入力欄・RTDB読み取り）はこの2関数を使い、API入力（tRPC）は valibot の制約に
* 定数をそのまま渡す。security rules だけは Bolt 側の `GlobalAIUsageAllocationRatePercent` /
* `GroupAIUsageAllocationRatePercent` に同じ範囲を書く。
*
* 全体設定とグループ上書きで上限が違うため関数も分けている。スコープを引数で渡す形にすると
* 取り違えても型が通り、上限額が静かにずれるため、呼び分けを名前で強制する。
*/
const isValidGlobalAIUsageAllocationRatePercent = (value) => isValidAllocationRatePercent(value, 100);
/**
* 全体設定用と上限が違うのは暫定の緩和のため。経緯と撤去手順は
* `MAX_GROUP_AI_USAGE_ALLOCATION_RATE_PERCENT` を参照。
* @see isValidGlobalAIUsageAllocationRatePercent
*/
const isValidGroupAIUsageAllocationRatePercent = (value) => isValidAllocationRatePercent(value, 500);
//#endregion
//#region src/schema/__app__/billing/billing-revisions/{groupId}/BillingRevisionJSON.ts
const BillingRevisionSchema = v.pipe(v.number(), v.integer(), v.minValue(1));
//#endregion
//#region src/schema/__app__/billing/group-profiles/{groupId}/GroupBillingProfileJSON.ts
const BillingMethodSchema = v.picklist([
	"no_charge",
	"invoice",
	"card"
]);
const StripeSubscriptionStatusSchema = v.picklist([
	"incomplete",
	"incomplete_expired",
	"trialing",
	"active",
	"past_due",
	"canceled",
	"unpaid",
	"paused"
]);
const nullableIdSchema = v.nullish(v.pipe(v.string(), v.minLength(1)), null);
const nullableSeatCountSchema = v.nullish(v.pipe(v.number(), v.integer(), v.minValue(0)), null);
const nullablePositiveSeatCountSchema = v.nullish(v.pipe(v.number(), v.integer(), v.minValue(1)), null);
const nullableTimestampSchema = v.nullish(timestampSchema, null);
const GroupBillingCheckoutAttemptSchema = v.pipe(v.object({
	id: v.pipe(v.string(), v.minLength(1)),
	billingManagerUserId: v.pipe(v.string(), v.minLength(1)),
	seatCount: v.pipe(v.number(), v.integer(), v.minValue(1)),
	stripePriceId: v.pipe(v.string(), v.minLength(1)),
	createdAt: timestampSchema,
	expiresAt: timestampSchema
}), v.check(({ createdAt, expiresAt }) => expiresAt.getTime() > createdAt.getTime(), "expiresAtはcreatedAtより後である必要があります"));
const GroupBillingProfileSchema = v.object({
	billingMethod: BillingMethodSchema,
	billingManagerUserId: nullableIdSchema,
	stripeCustomerId: nullableIdSchema,
	stripeSubscriptionId: nullableIdSchema,
	stripeSubscriptionItemId: nullableIdSchema,
	stripePriceId: nullableIdSchema,
	stripePortalConfigurationId: nullableIdSchema,
	portalMinimumSeatCount: nullablePositiveSeatCountSchema,
	stripeScheduleId: nullableIdSchema,
	/**
	* Subscriptionに紐づくactiveなScheduleの次フェーズで予定される総席数。増減の差分ではない。
	* 現在の席数と異なる予約がなければnull。
	*/
	scheduledSeatCount: nullablePositiveSeatCountSchema,
	scheduledSeatCountEffectiveAt: nullableTimestampSchema,
	/**
	* Subscription.pending_updateにある現在のItemの変更後総席数（支払い完了待ち）。
	* 該当するquantityがなければnull。GroupLicense.count（利用可能席数）には加算しない。
	*/
	pendingSeatCount: nullablePositiveSeatCountSchema,
	pendingUpdateExpiresAt: nullableTimestampSchema,
	paidPeriodEnd: nullableTimestampSchema,
	stripeStatus: v.nullish(StripeSubscriptionStatusSchema, null),
	cancelAtPeriodEnd: v.nullish(v.boolean(), null),
	currentPeriodEnd: nullableTimestampSchema,
	/**
	* カード払いでStripeの支払済みInvoiceから導出する席数スナップショット。
	* GroupLicense.countはこの値を反映したBalus上の利用可能席数とする。
	*/
	paidSeatCount: nullableSeatCountSchema,
	/**
	* Scheduleの次フェーズがあればその席数、それ以外は現在のSubscription Item quantityから同期する。
	* 現在のGroupLicense.count（利用可能席数）には直接反映しない。
	*/
	nextContractSeatCount: nullableSeatCountSchema,
	lastSyncedAt: nullableTimestampSchema,
	lastAppliedEventCreatedAt: nullableTimestampSchema,
	syncErrorSince: nullableTimestampSchema,
	lastSyncError: v.nullish(v.string(), null),
	checkoutAttempt: v.nullish(GroupBillingCheckoutAttemptSchema, null),
	updatedAt: timestampSchema
});
//#endregion
//#region src/schema/__app__/billing/operations/{groupId}/{operationId}/BillingOperationJSON.ts
const BillingOperationActionSchema = v.literal("changeSeatCount");
const BillingOperationRequesterRoleSchema = v.picklist(["groupAdmin", "balusOperator"]);
const BillingOperationStatusSchema = v.picklist([
	"requested",
	"stripeUpdated",
	"synced",
	"failed"
]);
const seatCountSchema = v.pipe(v.number(), v.integer(), v.minValue(0));
/**
* 席数変更要求からStripe更新、Webhook同期までの非同期処理状態を保持する可変レコード。
* GroupLicenseを変更した処理は、この状態更新に加えてGroupLicenseUpdateLogへ監査履歴を追記する。
*/
const BillingOperationSchema = v.object({
	operationId: v.pipe(v.string(), v.minLength(1)),
	groupId: v.pipe(v.string(), v.minLength(1)),
	action: BillingOperationActionSchema,
	previousSeatCount: seatCountSchema,
	requestedSeatCount: v.pipe(v.number(), v.integer(), v.minValue(1)),
	requestedBy: v.pipe(v.string(), v.minLength(1)),
	requesterRole: BillingOperationRequesterRoleSchema,
	reason: v.pipe(v.string(), v.minLength(1)),
	status: BillingOperationStatusSchema,
	stripeRequestId: v.nullish(v.pipe(v.string(), v.minLength(1)), null),
	stripeEventId: v.nullish(v.pipe(v.string(), v.minLength(1)), null),
	createdAt: timestampSchema,
	updatedAt: timestampSchema,
	error: v.nullish(v.string(), null)
});
//#endregion
//#region src/schema/__app__/billing/stripe-event-processings/{eventId}/StripeEventProcessingJSON.ts
const StripeEventProcessingSchema = v.object({
	eventId: v.pipe(v.string(), v.minLength(1)),
	eventType: v.pipe(v.string(), v.minLength(1)),
	stripeObjectId: v.pipe(v.string(), v.minLength(1)),
	processedAt: timestampSchema
});
//#endregion
//#region src/schema/__app__/billing/stripe-id-group-index/{stripeId}/StripeIdGroupIndexValueJSON.ts
const StripeIdGroupIndexValueSchema = v.pipe(v.string(), v.minLength(1));
//#endregion
//#region src/schema/__app__/group/assigned-group-index/{userId}/{groupId}/AssignedGroupIndexValueJSON.ts
const AssignedGroupIndexValueSchema = v.union([v.literal("N/A")]);
//#endregion
//#region src/schema/__app__/group/assigned-group-index/{userId}/AssignedGroupIndexJSON.ts
const AssignedGroupIndexSchema = v.record(v.string(), AssignedGroupIndexValueSchema);
//#endregion
//#region src/schema/__app__/group/entities/{groupId}/GroupJSON.ts
const GroupMemberSignUpMethodSchema = v.object({
	google: v.boolean(),
	microsoft: v.optional(v.boolean(), true),
	email: v.boolean()
});
const GroupSettingSchema = v.object({
	availableSignUpMethods: GroupMemberSignUpMethodSchema,
	enableIndividualViewModelPermissions: v.boolean(),
	defaultModelingFormat: v.union([v.literal("CJK"), v.literal("LATIN")])
});
const GroupSchema = v.object({
	id: v.string(),
	name: v.string(),
	imageUrl: v.nullish(v.string()),
	createdAt: timestampSchema,
	updatedAt: timestampSchema,
	setting: GroupSettingSchema,
	trashedAt: v.nullish(timestampSchema),
	trashedBy: v.nullish(v.string())
});
//#endregion
//#region src/schema/__app__/group/ip-restrictions/{groupId}/IpRestrictionConfiguration.ts
const defaultIpRestrictionConfiguration = {
	policy: "none",
	allowRules: []
};
//#endregion
//#region src/schema/__app__/group/licenses/{groupId}/GroupLicenseJSON.ts
const GROUP_LICENSE_TYPE_DICT = {
	standard: "スタンダード",
	academic: "アカデミック",
	trial: "トライアル",
	free: "フリー"
};
//#endregion
//#region src/schema/__app__/group/licenses/{groupId}/GroupLicenseSchema.ts
const GroupLicenseTypeSchema = v.union([
	v.literal("standard"),
	v.literal("academic"),
	v.literal("trial"),
	v.literal("free")
]);
const GroupLicenseSchema = v.object({
	type: GroupLicenseTypeSchema,
	count: v.number(),
	expiresAt: timestampSchema
});
//#endregion
//#region src/constants/ViewModelFileStorageLimit.ts
const ViewModelFileStorageLimitBytes = 1024 ** 3;
//#endregion
//#region src/group-license-permissions/GroupLicensePermissions.ts
const GROUP_LICENSE_PERMISSIONS = {
	standard: {
		ipRestrictionCheck: true,
		imageExport: true,
		fileUpload: true,
		unlimitedViewModelAccess: true,
		publicSpace: true,
		viewModelURLShare: true
	},
	academic: {
		ipRestrictionCheck: true,
		imageExport: true,
		fileUpload: true,
		unlimitedViewModelAccess: true,
		publicSpace: true,
		viewModelURLShare: true
	},
	trial: {
		ipRestrictionCheck: true,
		imageExport: true,
		fileUpload: true,
		unlimitedViewModelAccess: true,
		publicSpace: true,
		viewModelURLShare: true
	},
	free: {
		ipRestrictionCheck: false,
		imageExport: false,
		fileUpload: false,
		unlimitedViewModelAccess: false,
		publicSpace: false,
		viewModelURLShare: false
	}
};
//#endregion
//#region src/schema/__app__/group/license-notifications-completed/{jobId}/GroupLicenseNotificationCompletedJobJSON.ts
const GroupLicenseNotificationCompletedJobSchema = v.object({
	id: v.string(),
	groupId: v.string(),
	completedAt: timestampSchema
});
//#endregion
//#region src/schema/__app__/group/license-update-logs/{groupId}/{logId}/GroupLicenseUpdateLogJSON.ts
/**
* GroupLicenseへ実際に反映した変更の追記専用監査履歴。
* BillingOperationとは別に、GroupLicenseを変更した処理が記録する。
*/
const GroupLicenseUpdateLogSchema = v.object({
	/** 更新したライセンス情報 */
	license: GroupLicenseSchema,
	/** 更新時の内部メモ（未設定の場合あり） */
	internalNote: v.nullish(v.string()),
	/** 更新を行ったユーザーのメールアドレス */
	updatedBy: v.string(),
	/** 更新理由 */
	reason: v.string(),
	/** 更新日時 (Unix timestamp in milliseconds) */
	createdAt: timestampSchema
});
//#endregion
//#region src/schema/__app__/group/member-invitation-accepts/{groupId}/{userId}/GroupMemberInvitationAcceptanceJSON.ts
const GroupMemberInvitationAcceptanceSchema = v.string();
//#endregion
//#region src/schema/__common__/workspace/WorkspaceMemberRoleJSON.ts
const WorkspaceMemberRoleSchema = v.union([
	v.literal("admin"),
	v.literal("editor"),
	v.literal("viewer")
]);
//#endregion
//#region src/schema/__app__/group/member-invitation-workspaces/{groupId}/{userId}/GroupMemberInvitationWorkspacesJSON.ts
const GroupMemberInvitationWorkspacesSchema = v.record(v.string(), WorkspaceMemberRoleSchema);
//#endregion
//#region src/schema/__common__/group/GroupMemberRoleJSON.ts
const GroupMemberRoleSchema = v.union([
	v.literal("admin"),
	v.literal("member"),
	v.literal("guest")
]);
//#endregion
//#region src/schema/__app__/group/member-invitations/{groupId}/{invitationId}/GroupMemberInvitationJSON.ts
const InvitationSenderGroupSchema = v.object({
	groupId: v.string(),
	name: v.string(),
	imageUrl: v.nullish(v.string())
});
const InvitationSenderUserSchema = v.object({
	userId: v.string(),
	name: v.string(),
	email: v.string(),
	imageUrl: v.nullish(v.string())
});
const MemberInvitationSchema = v.object({
	email: v.string(),
	memberRole: GroupMemberRoleSchema,
	message: v.string(),
	baseUrl: v.string()
});
const GroupMemberInvitationSchema = v.object({
	id: v.string(),
	senderUser: InvitationSenderUserSchema,
	senderGroup: InvitationSenderGroupSchema,
	invitation: MemberInvitationSchema,
	active: v.boolean(),
	workspaces: v.nullish(v.record(v.string(), WorkspaceMemberRoleSchema)),
	createdAt: timestampSchema,
	updatedAt: timestampSchema,
	acceptedAt: v.nullish(timestampSchema),
	acceptedUserId: v.nullish(v.string()),
	expiresAt: timestampSchema,
	tokenHash: v.nullish(v.string())
});
//#endregion
//#region src/schema/__app__/group/member-roles/GroupMemberRolesJSON.ts
const GroupMemberRolesSchema = v.record(v.string(), GroupMemberRoleSchema);
//#endregion
//#region src/schema/__app__/user/active-auth-sessions/{sessionId}/AuthSessionJSON.ts
const AuthSessionSchema = v.object({
	sessionId: v.string(),
	userId: v.string(),
	userType: v.union([v.literal("regular"), v.literal("anonymous")]),
	currentIp: v.string(),
	signInAt: timestampSchema,
	updatedAt: timestampSchema,
	expiresAt: timestampSchema
});
//#endregion
//#region src/schema/__app__/user/active-client-sessions/ActiveClientSessionJSON.ts
const ActiveClientSessionSchema = v.object({
	clientId: v.pipe(v.string(), v.minLength(1)),
	startAt: timestampSchema,
	sessionId: v.nullish(v.string()),
	userId: v.nullish(v.string()),
	version: v.number(),
	updatedAt: timestampSchema,
	locationHref: v.nullish(v.string())
});
//#endregion
//#region src/schema/__app__/user/anonymous-users/{anonymousUserId}/AnonymousUserJSON.ts
const AnonymousUserSchema = v.object({
	id: v.string(),
	name: v.string(),
	imageUrl: v.nullish(v.string()),
	createdAt: timestampISOStringSchema,
	updatedAt: timestampISOStringSchema,
	signOutAt: v.nullish(timestampISOStringSchema)
});
//#endregion
//#region src/schema/__app__/user/auth-providers/{userId}/UserAuthProviderJSON.ts
const UserAuthProviderGoogleSchema = v.object({
	uid: v.pipe(v.string(), v.minLength(1)),
	email: v.nullish(v.string()),
	displayName: v.nullish(v.string()),
	photoURL: v.nullish(v.pipe(v.string(), v.url(), v.regex(/^https?:\/\//))),
	linkedAt: timestampSchema
});
const UserAuthProviderMicrosoftSchema = v.object({
	uid: v.pipe(v.string(), v.minLength(1)),
	email: v.nullish(v.string()),
	displayName: v.nullish(v.string()),
	linkedAt: timestampSchema
});
const UserAuthProviderSchema = v.object({
	id: v.pipe(v.string(), v.minLength(1)),
	google: v.nullish(UserAuthProviderGoogleSchema),
	microsoft: v.nullish(UserAuthProviderMicrosoftSchema),
	createdAt: timestampSchema,
	updatedAt: timestampSchema
});
//#endregion
//#region src/schema/__app__/user/credentials/{userId}/UserCredentialJSON.ts
const UserCredentialSchema = v.object({
	id: v.pipe(v.string(), v.minLength(1)),
	hashedPassword: v.nullish(v.pipe(v.string(), v.minLength(1))),
	passwordFailureCount: v.number(),
	lastLoginSuccessAt: timestampSchema,
	lastLoginTryAt: timestampSchema
});
//#endregion
//#region src/schema/__app__/user/entities/{userId}/UserEntityJSON.ts
const UserEntitySchema = v.object({
	id: v.string(),
	name: v.string(),
	imageUrl: v.nullish(v.string()),
	createdAt: timestampISOStringSchema,
	updatedAt: timestampISOStringSchema,
	mailAddress: v.string(),
	hasPassword: v.boolean(),
	withInvitation: v.nullish(v.boolean()),
	pendingMailAddress: v.nullish(v.string()),
	pendingMailAddressRequestedAt: v.nullish(timestampISOStringSchema)
});
//#endregion
//#region src/schema/__app__/user/login-identifiers/{id}/UserLoginIdentifierJSON.ts
const UserLoginIdentifierSchema = v.object({
	id: v.string(),
	userId: v.string(),
	mailAddress: v.pipe(v.string(), v.email()),
	hashedPassword: v.nullish(v.string()),
	createdAt: timestampISOStringSchema,
	updatedAt: timestampISOStringSchema,
	lastLoginAt: v.nullish(timestampISOStringSchema),
	passwordFailureCount: v.number()
});
/**
* メールアドレスを入力に受け取って、小文字に正規化した後、RTDBのパス階層で利用可能な文字列に変換する。
*
* 1. メールアドレスを小文字に変換する
* 2. RTDB のパス文字列に利用できない文字を % エスケープする
*    - 利用できない文字は `. $ # [ ] /`
*
* 参考:
*  - https://firebase.google.com/docs/database/usage/limits#data_tree
*
* @param email
* @returns
*/
const getUserLoginIdentifierFromEmail = (email) => email.toLowerCase().replace(/* @__PURE__ */ new RegExp("\\.", "g"), "%2E").replace(/* @__PURE__ */ new RegExp("\\$", "g"), "%24").replace(/* @__PURE__ */ new RegExp("\\[", "g"), "%5B").replace(/* @__PURE__ */ new RegExp("\\]", "g"), "%5D").replace(/* @__PURE__ */ new RegExp("/", "g"), "%2F");
//#endregion
//#region src/schema/__app__/user/mail-address-change-tokens/{token}/UserMailAddressChangeTokenJSON.ts
const UserMailAddressChangeTokenSchema = v.object({
	id: v.string(),
	userId: v.string(),
	previousMailAddress: v.string(),
	newMailAddress: v.string(),
	active: v.boolean(),
	requestIp: v.string(),
	createdAt: timestampSchema,
	updatedAt: timestampSchema,
	confirmedAt: v.nullish(timestampSchema),
	confirmedIp: v.nullish(v.string()),
	expiresAt: timestampSchema
});
//#endregion
//#region src/schema/__app__/user/onboarding-guide-completed/{jobId}/UserOnboardingGuideCompletedJobJSON.ts
const UserOnboardingGuideCompletedJobSchema = v.object({
	id: v.string(),
	userId: v.string(),
	completedAt: timestampSchema
});
//#endregion
//#region src/schema/__app__/user/onboarding-guide-stopped/{userId}/UserOnboardingGuideStoppedJSON.ts
const UserOnboardingGuideStoppedSchema = timestampSchema;
//#endregion
//#region src/schema/__app__/user/one-time-passwords/{temporaryId}/UserOneTimePasswordJSON.ts
const UserOneTimePasswordSchema = v.object({
	userId: v.string(),
	hashedPassword: v.string(),
	isVerified: v.boolean(),
	expiresAt: timestampISOStringSchema,
	createdAt: timestampISOStringSchema
});
//#endregion
//#region src/schema/__app__/user/password-reset-tokens/{token}/UserPasswordResetTokenJSON.ts
const UserPasswordResetTokenSchema = v.object({
	id: v.string(),
	userId: v.string(),
	mailAddress: v.string(),
	active: v.boolean(),
	requestIp: v.string(),
	createdAt: timestampISOStringSchema,
	updatedAt: timestampISOStringSchema,
	resetAt: v.nullish(timestampISOStringSchema),
	resetIp: v.nullish(v.string()),
	expiresAt: timestampISOStringSchema
});
//#endregion
//#region src/schema/__app__/user/public-profiles/{userId}/UserPublicProfileJSON.ts
const UserPublicProfileSchema = v.object({
	id: v.string(),
	name: v.string(),
	imageUrl: v.nullish(v.string()),
	isAnonymous: v.boolean()
});
//#endregion
//#region src/schema/__app__/user/signup-request-tokens/{id}/UserSignUpRequestTokenJSON.ts
const UserSignUpRequestTokenSchema = v.object({
	id: v.string(),
	name: v.string(),
	mailAddress: v.string(),
	loginIdentifier: v.nullish(v.string()),
	active: v.boolean(),
	requestIp: v.string(),
	createdAt: timestampISOStringSchema,
	updatedAt: timestampISOStringSchema,
	confirmAt: v.nullish(timestampISOStringSchema),
	confirmIp: v.nullish(v.string()),
	expiresAt: timestampISOStringSchema
});
//#endregion
//#region src/schema/__app__/user/survey-answer/{userId}/UserSurveyAnswerJSON.ts
const UserSurveyAnswerSchema = v.object({
	surveyId: v.string(),
	answeredAt: v.nullish(timestampSchema),
	canceledAt: v.nullish(timestampSchema)
});
//#endregion
//#region src/schema/__app__/view-model/contents/{viewModelId}/model-contents/{modelId}/annotation-links/{annotationLinkId}/AnnotationLinkJSON.ts
const AnnotationLinkStyles = ["wedge", "roundDot"];
const AnnotationLinkSchema = v.object({
	id: v.string(),
	fromKind: v.picklist(["FileContainer", "DescriptionPanel"]),
	fromId: v.string(),
	toKey: v.string(),
	style: v.picklist(AnnotationLinkStyles),
	reversed: v.optional(v.boolean()),
	bend: v.optional(v.object({
		r: v.number(),
		d: v.number()
	}))
});
//#endregion
//#region src/schema/__app__/view-model/contents/{viewModelId}/model-contents/{modelId}/file-containers/{fileContainerId}/FileContainerJSON.ts
const FileContainerSchema = v.object({
	id: v.string(),
	assetId: v.string(),
	filename: v.string(),
	fileSize: v.pipe(v.number(), v.integer(), v.minValue(1)),
	contentType: v.string(),
	size: v.object({
		width: v.number(),
		height: v.number()
	}),
	createdUserId: v.string(),
	createdAt: timestampSchema
});
//#endregion
//#region src/schema/__app__/view-model/entities/{viewModelId}/ViewModelJSON.ts
const ViewModelSchema = v.object({
	id: v.string(),
	workspaceId: v.string(),
	groupId: v.string(),
	name: v.string(),
	createdAt: timestampSchema,
	updatedAt: timestampSchema,
	trashedAt: v.nullish(timestampSchema),
	sharingUserRole: v.union([
		v.literal("None"),
		v.literal("Viewer"),
		v.literal("Editor")
	]),
	isLocked: v.boolean()
});
//#endregion
//#region src/ai/SkillTypes.ts
const RESERVED_BUNDLED_AI_ASSISTANT_SKILL_NAMES = /* @__PURE__ */ new Set(["skill-creator", "modeling"]);
function isReservedBundledAIAssistantSkillName(name) {
	return RESERVED_BUNDLED_AI_ASSISTANT_SKILL_NAMES.has(name);
}
const AIAssistantClientSkillIdSchema = v.pipe(v.string(), v.minLength(1), v.maxLength(120), v.regex(/^(?!(?:__proto__|constructor|prototype)$)[^.#$[\] /]+$/, "id に RTDB パスで利用できない文字または予約キーが含まれています"));
const AIAssistantClientSkillNameSchema = v.pipe(v.string(), v.minLength(1, "name は必須です"), v.maxLength(80, "name は80文字以内で入力してください"), v.regex(/^[a-zA-Z0-9][a-zA-Z0-9_-]*$/, "name は英数字、ハイフン、アンダースコアのみ利用できます"));
const AIAssistantClientSkillTriggerSchema = v.pipe(v.string(), v.minLength(2, "trigger は必須です"), v.maxLength(80, "trigger は80文字以内で入力してください"), v.regex(/^\/[a-zA-Z0-9][a-zA-Z0-9_-]*$/, "trigger は / で始まる英数字コマンドにしてください"));
const AIAssistantClientSkillSchema = v.object({
	id: AIAssistantClientSkillIdSchema,
	enabled: v.boolean(),
	name: AIAssistantClientSkillNameSchema,
	description: v.pipe(v.string(), v.maxLength(400, "description は400文字以内で入力してください")),
	triggers: v.pipe(v.array(AIAssistantClientSkillTriggerSchema), v.minLength(1), v.maxLength(5)),
	whenToUse: v.pipe(v.string(), v.maxLength(1e3, "whenToUse は1000文字以内で入力してください")),
	argumentHint: v.pipe(v.string(), v.maxLength(200, "argumentHint は200文字以内で入力してください")),
	prompt: v.pipe(v.string(), v.minLength(1, "prompt は必須です"), v.maxLength(2e4))
});
const AIAssistantClientSkillsSchema = v.pipe(v.array(AIAssistantClientSkillSchema), v.maxLength(20));
const AIAssistantClientSkillInputSchema = v.strictObject({
	enabled: v.optional(v.boolean()),
	name: AIAssistantClientSkillNameSchema,
	description: v.pipe(v.string(), v.maxLength(400, "description は400文字以内で入力してください")),
	triggers: v.pipe(v.array(AIAssistantClientSkillTriggerSchema), v.minLength(1), v.maxLength(5)),
	whenToUse: v.pipe(v.string(), v.maxLength(1e3, "whenToUse は1000文字以内で入力してください")),
	argumentHint: v.pipe(v.string(), v.maxLength(200, "argumentHint は200文字以内で入力してください")),
	prompt: v.pipe(v.string(), v.minLength(1, "prompt は必須です"), v.maxLength(2e4))
});
function toSkillSummary(skill) {
	return {
		id: skill.id,
		name: skill.name,
		description: skill.description,
		triggers: skill.triggers,
		argumentHint: skill.argumentHint,
		whenToUse: skill.whenToUse,
		source: skill.source
	};
}
//#endregion
//#region src/schema/__app__/view-model/ai-assistant-skills/{viewModelId}/{skillId}/AIAssistantViewModelSkillJSON.ts
const AIAssistantViewModelSkillSchema = AIAssistantClientSkillSchema;
//#endregion
//#region src/schema/__app__/view-model/ai-assistant-skills/{viewModelId}/AIAssistantViewModelSkillsJSON.ts
function isRecord$1(value) {
	return typeof value === "object" && value !== null && !Array.isArray(value);
}
function isAIAssistantViewModelSkillsJSON(value) {
	if (!isRecord$1(value)) return false;
	const entries = Object.entries(value);
	if (entries.length > 20) return false;
	return entries.every(([skillId, skill]) => {
		const parsedSkillId = v.safeParse(AIAssistantClientSkillIdSchema, skillId);
		const parsedSkill = v.safeParse(AIAssistantViewModelSkillSchema, skill);
		return parsedSkillId.success && parsedSkill.success && parsedSkill.output.id === skillId;
	});
}
const AIAssistantViewModelSkillsSchema = v.custom(isAIAssistantViewModelSkillsJSON, "Invalid view model AI assistant skills");
//#endregion
//#region src/schema/__app__/view-model/private-ai-assistant-chats/threads/{viewModelId}/{userId}/{threadId}/PrivateAIAssistantChatThreadJSON.ts
const PrivateAIAssistantChatThreadIdSchema = v.pipe(v.string(), v.minLength(1), v.maxLength(120), v.check((id) => /^[A-Za-z0-9_-]+$/.test(id), "id に RTDB パスで利用できない文字が含まれています"));
const PrivateAIAssistantChatThreadSchema = v.object({
	id: PrivateAIAssistantChatThreadIdSchema,
	title: v.pipe(v.string(), v.maxLength(200)),
	createdAt: v.number(),
	updatedAt: v.number()
});
//#endregion
//#region src/schema/__app__/view-model/private-ai-assistant-chats/messages/{viewModelId}/{userId}/{threadId}/{messageId}/PrivateAIAssistantChatMessageJSON.ts
const PrivateAIAssistantChatMessageIdSchema = v.pipe(v.string(), v.minLength(1), v.maxLength(120), v.check((id) => /^[A-Za-z0-9_-]+$/.test(id), "id に RTDB パスで利用できない文字が含まれています"));
const PrivateAIAssistantChatMessageRoleSchema = v.picklist([
	"system",
	"user",
	"assistant"
]);
const PrivateAIAssistantChatMessageSchema = v.object({
	id: PrivateAIAssistantChatMessageIdSchema,
	role: PrivateAIAssistantChatMessageRoleSchema,
	payload: v.pipe(v.string(), v.maxLength(1e6)),
	createdAt: v.number()
});
//#endregion
//#region src/schema/__app__/view-model/individual-permissions/{viewModelId}/ViewModelIndividualPermissionJSON.ts
const ViewModelIndividualPermissionRoleSchema = v.union([v.literal("editor"), v.literal("viewer")]);
const ViewModelIndividualPermissionRolesSchema = v.record(v.string(), ViewModelIndividualPermissionRoleSchema);
//#endregion
//#region src/schema/__app__/workspace/entities/{workspaceId}/WorkspaceJSON.ts
const WorkspaceSchema = v.object({
	id: v.string(),
	groupId: v.string(),
	name: v.string(),
	description: v.string(),
	imageUrl: v.nullish(v.string()),
	createdAt: timestampSchema,
	updatedAt: timestampSchema,
	setting: v.object({
		isPublicSpace: v.boolean(),
		isViewModelURLShareable: v.boolean(),
		enableIndividualViewModelPermissions: v.boolean(),
		modelingFormat: v.union([v.literal("CJK"), v.literal("LATIN")])
	}),
	isPersonal: v.boolean(),
	trashedAt: v.nullish(timestampSchema),
	trashedBy: v.nullish(v.string())
});
//#endregion
//#region src/schema/__app__/workspace/member-roles/WorkspaceMemberRolesJSON.ts
const WorkspaceMemberRolesSchema = v.record(v.string(), WorkspaceMemberRoleSchema);
//#endregion
//#region src/schema/__auth__/AuthCustomClaimJSON.ts
const AuthCustomClaimSchema = v.object({
	userId: v.string(),
	userType: v.union([v.literal("regular"), v.literal("anonymous")]),
	sessionId: v.string()
});
//#endregion
//#region src/schema/__common__/app/ReleaseToggleDefinitions.ts
const ReleaseToggleDefinitions = {
	_sample: "サンプルトグル。削除しないでください。",
	cardSubscriptionCheckout: "カード払いのサブスクリプション申込みUIとAPIを有効にします。"
};
const ReleaseToggleNames = Object.keys(ReleaseToggleDefinitions).sort();
//#endregion
//#region src/schema/__common__/base/id.ts
/**
* RTDBのパス階層に指定するidとして適切な場合にtrueを返します。
* パス文字列に含めることのできない以下の記号に加えて、階層区切り文字 "/" と空白文字 " " も利用禁止とする。
* Paths must be non-empty strings and can't contain ".", "#", "$", "[", or "]"
* @param id
* @returns
*/
function isValidId(id) {
	return /^[^.#$[\] /]+$/.test(id);
}
//#endregion
//#region src/schema/__common__/base/NoAssign.ts
const NO_ASSIGN = "N/A";
//#endregion
//#region src/utils/undefinedToNullField.ts
function undefinedToNullField(value) {
	if (value === void 0 || value === null) return null;
	if (Array.isArray(value)) return value.map((v) => undefinedToNullField(v));
	if (typeof value === "object") {
		const result = {};
		for (const key in value) if (Object.prototype.hasOwnProperty.call(value, key)) result[key] = undefinedToNullField(value[key]);
		return result;
	}
	return value;
}
//#endregion
//#region src/utils/StoragePath.ts
var StoragePath = class {
	/**
	* 一般公開されたリソースアイコンの永続化パスを返す
	*/
	static publicIconPath(resourceType, resourceId, filename) {
		return [
			"public-icons",
			resourceType,
			resourceId,
			filename
		].join("/");
	}
	/**
	* ビューモデルに貼付されたアセットの永続化パスを返す
	*/
	static viewModelAssetPath(groupId, viewModelId, assetId) {
		return [
			"view-model-assets",
			groupId,
			viewModelId,
			assetId
		].join("/");
	}
	static viewModelAssetTrashPath(groupId, viewModelId, assetId) {
		return [
			"view-model-assets-trash",
			groupId,
			viewModelId,
			assetId
		].join("/");
	}
	/**
	* AIアシスタントのチャット入力欄に添付された画像の永続化パスを返す。
	* userId を含めることで storage.rules で本人のパスにのみ書き込みを許可し、
	* threadId を含めることで調査時にスレッド単位で辿れるようにする。
	*/
	static aiChatImagePath(groupId, viewModelId, userId, threadId, imageId) {
		return [
			"ai-chat-images",
			groupId,
			viewModelId,
			userId,
			threadId,
			imageId
		].join("/");
	}
	/**
	* AIアシスタントのチャット入力欄に添付されたファイル（スプレッドシート等）の永続化パスを返す。
	* 画像（aiChatImagePath）と同じく userId を含めて storage.rules で本人のパスにのみ書き込みを許可し、
	* threadId を含めることで調査時にスレッド単位で辿れるようにする。
	*/
	static aiChatFilePath(groupId, viewModelId, userId, threadId, fileId) {
		return [
			"ai-chat-files",
			groupId,
			viewModelId,
			userId,
			threadId,
			fileId
		].join("/");
	}
	/**
	* AIアシスタントのチャット入力欄に添付されたテキストファイル（md/txt等）の永続化パスを返す。
	* スプレッドシート（aiChatFilePath）とは content 判定方式が異なる（拡張子allowlistではなく
	* UTF-8/Shift_JIS/UTF-16(BOM付き)のいずれかとして妥当にデコードできるか）ため、
	* storage.rules の contentType 制約を分けられるよう別パスにしている。
	*/
	static aiChatTextFilePath(groupId, viewModelId, userId, threadId, fileId) {
		return [
			"ai-chat-text-files",
			groupId,
			viewModelId,
			userId,
			threadId,
			fileId
		].join("/");
	}
};
//#endregion
//#region src/utils/canEditViewModel.ts
const canEditViewModel = (workspaceMemberRole, isIndividualPermissionEnabled, individualPermissionRole, isViewModelURLShareable, sharingUserRole) => {
	return !!workspaceMemberRole && ["admin", "editor"].includes(workspaceMemberRole) || isViewModelURLShareable && sharingUserRole === "Editor" || isIndividualPermissionEnabled && individualPermissionRole === "editor";
};
//#endregion
//#region src/utils/extractId.ts
function extractId(key) {
	const parts = key.split(":");
	if (parts.length <= 1) throw new Error(`Invalid key format: ${key}`);
	return parts.slice(1).join(":");
}
//#endregion
//#region src/utils/PasswordStrengthOptions.ts
/**
* パスワードの強度を判定するためのオプションです。
* check-password-strength パッケージに渡すための形式で定義しています。
*/
const PasswordStrengthOptions = [
	{
		id: 0,
		value: "Too weak",
		minDiversity: 0,
		minLength: 0
	},
	{
		id: 1,
		value: "Weak",
		minDiversity: 2,
		minLength: 6
	},
	{
		id: 2,
		value: "Medium",
		minDiversity: 4,
		minLength: 8
	},
	{
		id: 3,
		value: "Strong",
		minDiversity: 4,
		minLength: 10
	}
];
//#endregion
//#region src/utils/ModelingFormat.ts
const ModelingFormatSchema = v.union([v.literal("CJK"), v.literal("LATIN")]);
const ModelingFormatList = Object.keys({
	CJK: null,
	LATIN: null
});
const StickyNodeSizeByModelingFormat = {
	CJK: {
		width: 256,
		height: 256
	},
	LATIN: {
		width: 384,
		height: 256
	}
};
const DEFAULT_MODELING_FORMAT = "CJK";
//#endregion
//#region src/utils/ModelGrid.ts
const MODEL_GRID_SIZE = 64;
const VIEW_GRID_SIZE = 512;
/**
* 値を最も近いモデルグリッド格子点(64pxの倍数)に丸める。
* webapp の GridLayout.snapX/snapY と同じ計算式。
*/
function snapToModelGrid(value) {
	const gridPosition = Math.abs(value) + 32;
	const gridIndex = Math.trunc(gridPosition / 64);
	return Math.sign(value) * (gridIndex * 64);
}
function snapPositionToModelGrid(position) {
	return {
		x: snapToModelGrid(position.x),
		y: snapToModelGrid(position.y)
	};
}
//#endregion
//#region src/utils/ViewModelCanvas.ts
const VIEW_MODEL_CANVAS_SIZE = 204800;
const VIEW_MODEL_CANVAS_BOUNDS = {
	min: -102400,
	max: VIEW_MODEL_CANVAS_SIZE / 2
};
//#endregion
//#region src/utils/AIAssistantMemberSettings.ts
const AI_ASSISTANT_MEMBER_SETTINGS_MAX_PER_REQUEST = 500;
//#endregion
//#region src/ai/AIViewModelContext.ts
const AIViewModelContextThemeColor = v.picklist([
	"White",
	"Red",
	"Green",
	"Blue",
	"Orange",
	"Yellow",
	"YellowGreen",
	"Purple"
]);
const AIViewModelContextStickyNodeStyle = v.object({
	themeColor: v.pipe(AIViewModelContextThemeColor, v.description("付箋のテーマカラー")),
	strikethrough: v.pipe(v.boolean(), v.description("打ち消し線のスタイルを適用するかどうか"))
});
const AIViewModelContextStickyNodeReactions = v.pipe(v.record(v.string(), v.number()), v.description("この付箋への絵文字リアクション。キーにリアクションの種類（thumbsup, tada, heart, eyes, bowing, check など）、値にそのリアクションがされた回数を保持する"));
const AIViewModelContextElementDescriptionRelativePosition = v.pipe(v.object({
	x: v.number(),
	y: v.number()
}), v.description("補足説明（吹き出し）の位置。要素の左上から吹き出しの左上までの相対座標(px)です。吹き出しは描画時に要素の周囲へ吸着するため、要素から離れた位置を指定しても要素に接する位置に表示されます。吹き出しの大きさは指定できず、幅は512px、高さは本文の量に応じて伸びます（最低256px）。省略すると既存の補足説明は現在の位置を維持します。"));
const AIViewModelContextElementDescriptionVisible = v.pipe(v.boolean(), v.description("補足説明（吹き出し）を表示するかどうか。ユーザーが非表示にした補足説明は false で、吹き出しは描画されませんが本文は保持されます。表示中の補足説明では省略されています。省略すると既存の補足説明は現在の表示状態を維持し、新しい補足説明は表示されます。表示状態を変えない更新では、取得した値を書き戻さずに省略してください（取得後にユーザーが切り替えた表示状態を上書きしないため）。ユーザーに補足説明の追加や表示を依頼されたときに false の補足説明があれば true にしてください。"));
function buildElementDescriptionSchema(contentDescription) {
	return v.object({
		content: v.pipe(v.string(), v.description(contentDescription)),
		relativePosition: v.optional(AIViewModelContextElementDescriptionRelativePosition),
		visible: v.optional(AIViewModelContextElementDescriptionVisible)
	});
}
const AIViewModelContextStickyNode = v.object({
	id: v.string(),
	content: v.pipe(v.string(), v.description("付箋の名前。目安20字以内に収めてください")),
	description: v.optional(v.pipe(buildElementDescriptionSchema("補足説明の本文。目安50字以内、長くても100字以内にします（ユーザーに長い説明を依頼された場合を除く）。"), v.description("付箋の補足説明（吹き出し）。その付箋1つだけにかかる定義・具体例・根拠などを書く場合に設定します。名前の言い換えや、複数の要素にまたがる説明には使わないでください。同じ種類の付箋に一貫して付ける場合を除き、1ビューに数個までに絞ってください。"))),
	style: AIViewModelContextStickyNodeStyle,
	position: v.object({
		x: v.number(),
		y: v.number()
	}),
	size: v.object({
		width: v.number(),
		height: v.number()
	}),
	url: v.optional(v.pipe(v.string(), v.nonEmpty(), v.url(), v.description("付箋に紐づくURLリンク。原則として設定しないでください。ユーザーやビューモデルの内容として実在が確認できるURLが提示されている場合のみ設定します。URLを推測して組み立ててはいけません。"))),
	reactions: v.optional(AIViewModelContextStickyNodeReactions)
});
const AIViewModelContextLinkMarkStyle = v.picklist([
	"NoMark",
	"Arrow",
	"TwoWayArrow",
	"Diamond",
	"HollowDiamond",
	"HollowTriangle"
]);
const AIViewModelContextLinkThemeColor = v.picklist([
	"Gray",
	"Red",
	"Blue"
], "リンクの色は Gray / Red / Blue の3色だけです。付箋・ゾーンのテーマカラー（Green, Purple, Orange, Yellow, YellowGreen, White）はリンクには使えません。基本は Gray を使い、強調したいリンクだけ Red または Blue にしてください。");
const AIViewModelContextLinkLineStyle = v.picklist(["Dashed", "Solid"]);
const AIViewModelContextLinkStyle = v.object({
	line: AIViewModelContextLinkLineStyle,
	mark: v.pipe(AIViewModelContextLinkMarkStyle, v.description("リンクの端に描くマーク。TwoWayArrow 以外のマークは終点(to)側の端にだけ描かれます。集約・コンポジション(HollowDiamond / Diamond)はひし形が全体側に付くよう from に部分、to に全体を指定し、汎化(HollowTriangle)は from に子、to に親を指定してください。")),
	themeColor: v.pipe(AIViewModelContextLinkThemeColor, v.description("リンクの色。付箋・ゾーンのテーマカラーとは別の色セットで、Gray / Red / Blue の3色しか指定できません。基本は Gray、強調したいリンクだけ Red または Blue にしてください。"))
});
const AIViewModelContextLinkBendValue = v.pipe(v.number(), v.minValue(-1e9), v.maxValue(1e9));
const AIViewModelContextLinkBend = v.object({
	r: AIViewModelContextLinkBendValue,
	d: AIViewModelContextLinkBendValue
});
const AIViewModelContextLinkMultiplicity = v.object({
	lower: v.number(),
	upper: v.number()
});
const AIViewModelContextLink = v.pipe(v.object({
	id: v.string(),
	from: v.pipe(v.string(), v.description("始点となるゾーンや付箋のID")),
	to: v.pipe(v.string(), v.description("終点となるゾーンや付箋のID")),
	bend: v.optional(v.pipe(AIViewModelContextLinkBend, v.description("リンクの曲げ。rは両端を結ぶ線上の位置(通常は0〜1の割合)、dはその線から曲線が通過する点(曲げの制御点)までの垂直距離(px)で、dが0なら直線です。既存リンクで省略すると現在値を維持し、新規リンクで省略すると直線になります。曲がっている既存リンクを直線に戻すときは、省略せずに {\"r\":0.5,\"d\":0} を指定してください。自動配置ではrを0.25/0.5/0.75、dを64px単位で指定します。"))),
	label: v.optional(v.pipe(v.string(), v.description("リンクのラベル。原則として設定せず、関係の意味づけが本当に必要なときだけ短いフレーズを設定します。ラベルは bend で指定した曲げの制御点（曲げていない場合は両端を結ぶ線の中点）に重ねて描画され、自動折り返しはされません（改行を入れない限り1行になります）。そのため、両端の要素の間隔がラベルの表示幅（全角1文字あたり36px＋左右の余白36px、最低180px）より狭いと、両端の要素に食い込んで読めなくなります。端点ではない付箋や別のリンクのラベルと重なる場合は、bend でラベルの位置をずらせます。"))),
	style: AIViewModelContextLinkStyle,
	sourceMultiplicity: v.optional(v.pipe(AIViewModelContextLinkMultiplicity, v.description("始点側の多重度。原則として設定しないでください。通常のモデリングでは関係の種類は矢印スタイルで表現できるため多重度は不要です。UMLクラス図・ER図など多重度が本質的に必要なモデリングをユーザーが明示的に依頼した場合のみ設定します。lower/upperは多重度の下限・上限で、上限が無制限の場合はupperに-1を指定します。"))),
	targetMultiplicity: v.optional(v.pipe(AIViewModelContextLinkMultiplicity, v.description("終点側の多重度。設定してよい条件は sourceMultiplicity と同じで、原則として設定しないでください。")))
}), v.description("要素同士をつなぐリンク。from/to は要素IDを指す。"));
const AIViewModelContextZoneFontSize = v.picklist([
	"S",
	"M",
	"L",
	"XL",
	"XXL"
]);
const AIViewModelContextZoneTextAlign = v.picklist([
	"Left",
	"Center",
	"Right"
]);
const AIViewModelContextZoneShape = v.picklist(["Rectangle", "Circle"]);
const AIViewModelContextZoneTitlePosition = v.picklist([
	"Top",
	"Bottom",
	"Left",
	"Right"
]);
const AIViewModelContextZone = v.pipe(v.object({
	id: v.string(),
	name: v.string(),
	position: v.object({
		x: v.number(),
		y: v.number()
	}),
	size: v.pipe(v.object({
		width: v.number(),
		height: v.number()
	}), v.description("64px単位で指定してください。内部要素を囲むのに必要な最小限のサイズ（幅は内部要素全体の幅+左右64pxずつ、高さは内部要素全体の高さ+上部192px以上+下部64px）にとどめ、必要以上に大きくしないでください。")),
	description: v.pipe(v.optional(buildElementDescriptionSchema("補足説明の本文。目安50字以内、長くても100字以内にします（ユーザーに長い説明を依頼された場合を除く）。")), v.description("ゾーンについての補足説明（吹き出し）。そのゾーン1つだけにかかる定義・根拠などを書く場合に設定します。吹き出しはゾーンの枠の外に出るため、外側に空きがあるゾーンにだけ付けてください。同じ種類のゾーンに一貫して付ける場合を除き、1ビューに数個までに絞ってください。")),
	url: v.pipe(v.optional(v.string()), v.description("ゾーンに紐づくURLリンク。原則として設定しないでください。ユーザーやビューモデルの内容として実在が確認できるURLが提示されている場合のみ設定します。URLを推測して組み立ててはいけません。")),
	style: v.optional(v.object({
		themeColor: AIViewModelContextThemeColor,
		fontSize: AIViewModelContextZoneFontSize,
		textAlign: v.pipe(v.optional(AIViewModelContextZoneTextAlign), v.description("ゾーン名のテキスト配置。省略時はCenter")),
		shape: v.pipe(v.optional(AIViewModelContextZoneShape), v.description("ゾーンの形状。四角形(Rectangle)または円形(Circle)。省略時はRectangle")),
		titlePosition: v.pipe(v.optional(AIViewModelContextZoneTitlePosition), v.description("ゾーン名の表示位置。省略時はTop"))
	}))
}), v.description("付箋などを囲む領域としてのゾーン。"));
const AIViewModelContextDescriptionPanel = v.pipe(v.object({
	id: v.string(),
	content: v.pipe(v.string(), v.description("パネルの内容を Markdown で記述します。見出し・段落・箇条書き・番号付きリスト・引用・水平線・コードブロック・太字・斜体・インラインコード・リンク・画像が利用できます。表・タスクリスト・打ち消し線・生のHTMLは記法として解釈されないため使わないでください。")),
	position: v.object({
		x: v.number(),
		y: v.number()
	}),
	size: v.object({
		width: v.number(),
		height: v.number()
	})
}), v.description("説明パネル。"));
const AIViewModelContextView = v.object({
	id: v.string(),
	name: v.string(),
	nodes: v.array(AIViewModelContextStickyNode),
	links: v.array(AIViewModelContextLink),
	zones: v.array(AIViewModelContextZone),
	descriptionPanels: v.array(AIViewModelContextDescriptionPanel),
	position: v.pipe(v.object({
		x: v.number(),
		y: v.number()
	}), v.description("キャンバス上でのビュー左上の絶対座標。512px単位で指定してください。既存のビューと重ならない位置を指定します。")),
	size: v.pipe(v.object({
		width: v.number(),
		height: v.number()
	}), v.description("512px単位で設定してください｡高さは最低でも2048、幅は3584に設定してください｡"))
});
const AIViewModelContextConsistencyLink = v.pipe(v.object({
	id: v.string(),
	from: v.pipe(v.string(), v.description("接続元のビューID")),
	to: v.pipe(v.string(), v.description("接続先のビューID"))
}), v.description("ビュー同士をつなぐ整合性リンク。互いに整合しているべきビューの関係を表す。各ビューの links（ビュー内の付箋・ゾーン同士のリンク）とは別物で、from/to はビューIDを指す。画面上は向きのない線で描かれるため、from/to の向きに意味はない。"));
const AIViewModelContextSchema = v.object({
	name: v.string(),
	views: v.array(AIViewModelContextView),
	consistencyLinks: v.optional(v.array(AIViewModelContextConsistencyLink)),
	modelingFormat: v.optional(v.pipe(v.picklist(["CJK", "LATIN"]), v.description("ビューモデルのモデリングフォーマット。付箋サイズが異なる")))
});
//#endregion
//#region src/ai/AIViewModelEdit.ts
const AIViewModelEdit = v.pipe(v.object({ views: v.array(AIViewModelContextView) }), v.metadata({ description: "ビューモデルに要素を追加したり編集するためのインターフェイス" }));
//#endregion
//#region src/ai/AIViewModelPatch.ts
const AIViewModelPatchView = v.pipe(v.object({
	id: v.pipe(v.string(), v.description("編集対象のビューID")),
	name: v.optional(v.pipe(v.string(), v.description("ビュー名を変更する場合に指定"))),
	size: v.optional(v.pipe(v.object({
		width: v.number(),
		height: v.number()
	}), v.description("ビューサイズを変更する場合に指定。512px単位で設定してください。"))),
	nodes: v.optional(v.pipe(v.array(AIViewModelContextStickyNode), v.description("追加・更新する付箋。既存IDなら上書き更新、新規IDなら追加。"))),
	links: v.optional(v.pipe(v.array(AIViewModelContextLink), v.description("追加・更新するリンク。既存IDなら上書き更新、新規IDなら追加。"))),
	zones: v.optional(v.pipe(v.array(AIViewModelContextZone), v.description("追加・更新するゾーン。既存IDなら上書き更新、新規IDなら追加。"))),
	descriptionPanels: v.optional(v.pipe(v.array(AIViewModelContextDescriptionPanel), v.description("追加・更新する説明パネル。既存IDなら上書き更新、新規IDなら追加。"))),
	removeIds: v.optional(v.pipe(v.array(v.string()), v.description("削除する要素のID（付箋・リンク・ゾーン・説明パネル共通）")))
}), v.description("ビューに対する差分編集操作。要素の追加・更新・削除ができる。"));
const AIViewModelPatch = v.pipe(v.object({ views: v.array(AIViewModelPatchView) }), v.metadata({ description: "ビューモデルの差分編集インターフェイス。既存ビューに対して部分的な追加・更新・削除ができる。" }));
//#endregion
//#region src/ai/AIViewModelContextLinkUtils.ts
/**
* リンクに指定できない色を、意味の近いリンク色へ写像する表。
* 付箋・ゾーンのテーマカラー(8色)はリンクでは使えないため、AIがそれらを指定してきたときの受け皿にする。
* - 強調・警告に使われる暖色は Red
* - それ以外の色分けに使われる色は Blue
* - 無彩色は Gray
*/
const LINK_THEME_COLOR_BY_ALIAS = {
	white: "Gray",
	gray: "Gray",
	red: "Red",
	orange: "Red",
	yellow: "Red",
	blue: "Blue",
	green: "Blue",
	yellowgreen: "Blue",
	purple: "Blue"
};
var AIViewModelContextLinkUtils = class {
	static parseThemeColor(color) {
		const result = v.safeParse(AIViewModelContextLinkThemeColor, color);
		return result.success ? result.output : null;
	}
	/**
	* リンクの色として使えない値を、指定できる3色のいずれかに寄せる。
	* 対応表にない値は Gray として扱う（リンクの既定色）。
	*/
	static normalizeThemeColor(color) {
		return this.parseThemeColor(color) ?? LINK_THEME_COLOR_BY_ALIAS[color.toLowerCase()] ?? "Gray";
	}
	static parseMarkStyle(markStyle) {
		const result = v.safeParse(AIViewModelContextLinkMarkStyle, markStyle);
		return result.success ? result.output : null;
	}
	static parseLineStyle(lineStyle) {
		const result = v.safeParse(AIViewModelContextLinkLineStyle, lineStyle);
		return result.success ? result.output : null;
	}
};
//#endregion
//#region src/ai/AIViewModelContextUtils.ts
var AIViewModelContextUtils = class {
	static parseThemeColor(color) {
		const result = v.safeParse(AIViewModelContextThemeColor, color);
		return result.success ? result.output : null;
	}
	static parseZoneFontSize(fontSize) {
		const result = v.safeParse(AIViewModelContextZoneFontSize, fontSize);
		return result.success ? result.output : null;
	}
	static parseZoneTextAlign(textAlign) {
		const result = v.safeParse(AIViewModelContextZoneTextAlign, textAlign);
		return result.success ? result.output : null;
	}
	static parseZoneShape(shape) {
		const result = v.safeParse(AIViewModelContextZoneShape, shape);
		return result.success ? result.output : null;
	}
	static parseZoneTitlePosition(titlePosition) {
		const result = v.safeParse(AIViewModelContextZoneTitlePosition, titlePosition);
		return result.success ? result.output : null;
	}
	static toElementDescription(description) {
		if (!description) return void 0;
		return {
			content: description.content,
			relativePosition: description.relativePosition,
			...description.visible ? {} : { visible: false }
		};
	}
};
//#endregion
//#region src/ai/AIViewModelEditUtils.ts
var AIViewModelEditUtils = class AIViewModelEditUtils {
	/**
	* generateIds ツールが発行するIDの形式(nanoidのデフォルト: 21文字)。
	* AIが新規要素に指定するIDはこの形式でなければならない。
	*/
	static GENERATED_ID_PATTERN = /^[A-Za-z0-9_-]{21}$/;
	/**
	* ビュー内の要素IDを検証する。
	*
	* - 新規要素(isExistingId が false を返すID)のIDは GENERATED_ID_PATTERN に一致しなければならない。
	*   AIが自分で考えた仮ID(例: "node-1")をそのまま永続化しないようにするため。
	* - 同一ビュー内でIDが重複してはならない。
	*
	* @param isExistingId 既存要素のIDなら true を返す関数(新規ビューでは常に false)
	*/
	static validateViewElementIds(view, isExistingId = () => false) {
		const ids = [
			...(view.nodes ?? []).map((n) => n.id),
			...(view.zones ?? []).map((z) => z.id),
			...(view.descriptionPanels ?? []).map((p) => p.id),
			...(view.links ?? []).map((l) => l.id)
		];
		const invalidIds = [];
		const duplicatedIds = [];
		const seen = /* @__PURE__ */ new Set();
		for (const id of ids) {
			if (seen.has(id)) duplicatedIds.push(id);
			seen.add(id);
			if (!isExistingId(id) && !AIViewModelEditUtils.GENERATED_ID_PATTERN.test(id)) invalidIds.push(id);
		}
		return {
			invalidIds,
			duplicatedIds
		};
	}
	/**
	* AIViewModelEdit内の各オブジェクトのIDを新しいIDで置換する
	* リンクのfrom/toも対応するノード/ゾーンの新IDに更新される
	*/
	static replaceIds(edit, generateId) {
		return { views: edit.views.map((view) => {
			const idMap = /* @__PURE__ */ new Map();
			const newViewId = generateId();
			idMap.set(view.id, newViewId);
			const newNodes = view.nodes.map((node) => {
				const newId = generateId();
				idMap.set(node.id, newId);
				return {
					...node,
					id: newId
				};
			});
			const newZones = view.zones.map((zone) => {
				const newId = generateId();
				idMap.set(zone.id, newId);
				return {
					...zone,
					id: newId
				};
			});
			const newDescriptionPanels = view.descriptionPanels.map((panel) => {
				const newId = generateId();
				idMap.set(panel.id, newId);
				return {
					...panel,
					id: newId
				};
			});
			const newLinks = view.links.map((link) => {
				const newId = generateId();
				const newFrom = idMap.get(link.from) ?? link.from;
				const newTo = idMap.get(link.to) ?? link.to;
				return {
					...link,
					id: newId,
					from: newFrom,
					to: newTo
				};
			});
			return {
				...view,
				id: newViewId,
				nodes: newNodes,
				zones: newZones,
				descriptionPanels: newDescriptionPanels,
				links: newLinks
			};
		}) };
	}
};
//#endregion
//#region src/ai/AIAssistantMode.ts
/**
* AIアシスタントのモード定義。
* フロントエンド・バックエンドの両方で共通して参照する。
*
* - chat: 閲覧と会話のみ。ビューモデルの編集はできない（閲覧ツール + Skill ツールのみ）。
* - modeling: モデリング用の全ツール（閲覧 + 検証/ID採番 + ビュー編集 + Skill）が使える。
*/
const AIAssistantModes = ["chat", "modeling"];
/** 新規チャット開始時のデフォルトモード。 */
const DEFAULT_AI_ASSISTANT_MODE = "chat";
function isAIAssistantMode(value) {
	return typeof value === "string" && AIAssistantModes.includes(value);
}
//#endregion
//#region src/ai/AIAssistantToolNames.ts
/**
* AIアシスタントが利用するツール名の定数定義。
* フロントエンド・バックエンドの両方で共通して参照する。
*/
const AIAssistantToolNames = {
	getViews: "getViews",
	getViewContent: "getViewContent",
	getCurrentViews: "getCurrentViews",
	generateIds: "generateIds",
	skillList: "skillList",
	skill: "skill",
	readAttachedSpreadsheet: "readAttachedSpreadsheet",
	readAttachedTextFile: "readAttachedTextFile",
	fetchUrl: "fetchUrl",
	searchViewModels: "searchViewModels",
	getOtherViewModelViews: "getOtherViewModelViews",
	getOtherViewModelViewContent: "getOtherViewModelViewContent",
	addView: "addView",
	patchView: "patchView",
	switchMode: "switchMode",
	listClientSkills: "listClientSkills",
	getClientSkill: "getClientSkill",
	createClientSkill: "createClientSkill",
	updateClientSkill: "updateClientSkill",
	exportFile: "exportFile",
	getViewImage: "getViewImage"
};
//#endregion
//#region src/ai/AIAssistantClientToolDefs.ts
/**
* switchMode ツールの入力スキーマ。切り替え先のモードを指定する。
*/
const AIAssistantSwitchModeInput = v.object({ mode: v.picklist(AIAssistantModes) });
const AIAssistantCreateClientSkillInput = v.strictObject({ skill: AIAssistantClientSkillInputSchema });
const AIAssistantUpdateClientSkillInput = v.strictObject({
	id: AIAssistantClientSkillIdSchema,
	skill: AIAssistantClientSkillInputSchema
});
const AIAssistantListClientSkillsInput = v.object({});
const AIAssistantGetClientSkillInput = v.object({ id: AIAssistantClientSkillIdSchema });
/** exportFile: セルの合計数の上限。履歴1MB制約から逆算した暫定値（03計画 §5-1）。 */
const AI_EXPORT_FILE_MAX_CELLS = 5e3;
/** exportFile: 1セルあたりの文字数上限。 */
const AI_EXPORT_FILE_MAX_CELL_LENGTH = 500;
function hasControlChar(value) {
	for (let i = 0; i < value.length; i++) {
		const code = value.charCodeAt(i);
		if (code < 32 || code === 127) return true;
	}
	return false;
}
function isHighSurrogate(code) {
	return code >= 55296 && code <= 56319;
}
function isLowSurrogate(code) {
	return code >= 56320 && code <= 57343;
}
function hasDisallowedContentChar(value) {
	for (let i = 0; i < value.length; i++) {
		const code = value.charCodeAt(i);
		if (code === 9 || code === 10 || code === 13) continue;
		if (code < 32 || code === 127) return true;
		if (isHighSurrogate(code)) {
			if (!isLowSurrogate(value.charCodeAt(i + 1))) return true;
			i++;
			continue;
		}
		if (isLowSurrogate(code)) return true;
	}
	return false;
}
const AIAssistantExportFileCellSchema = v.union([
	v.pipe(v.string(), v.maxLength(500)),
	v.number(),
	v.boolean(),
	v.null()
]);
const AIAssistantExportFileSheetSchema = v.object({
	name: v.optional(v.pipe(v.string(), v.maxLength(100))),
	rows: v.array(v.array(AIAssistantExportFileCellSchema)),
	columnWidths: v.optional(v.array(v.pipe(v.number(), v.minValue(0), v.maxValue(255)))),
	headerRowCount: v.optional(v.pipe(v.number(), v.integer(), v.minValue(0)))
});
const AIAssistantExportFileFilenameSchema = v.pipe(v.string(), v.minLength(1), v.maxLength(100), v.regex(/^[^/\\]+$/u, "filename にパス区切り文字は使えません"), v.check((value) => !hasControlChar(value), "filename に制御文字は使えません"));
/**
* exportFile: テキスト（md/txt）の文字数上限。表形式と違いセル分割がないため単一の上限で足りる。
* JSON.stringify後の合計文字数上限（exportChatFile.ts の EXPORT_FILE_MAX_SERIALIZED_CHARS=300,000）に
* 対しては、改行・タブ・復帰・引用符・バックスラッシュ等はエスケープで最大2倍程度に膨らみ得るため、
* 余裕を持たせた値にしている（この上限文字数ちょうどでも安全に収まることをテストで確認済み）。
* この「最大2倍」の前提は、短いエスケープを持たない文字（NUL等の制御文字・孤立サロゲート。
* いずれも\uXXXXへ6文字に展開される）を hasDisallowedContentChar で拒否していることに依存する。
*/
const AI_EXPORT_TEXT_MAX_CHARS = 1e5;
function isExportTextFormat(format) {
	return format === "md" || format === "txt";
}
/**
* exportFile ツールの入力スキーマ。format によって表形式（xlsx/csv/tsv）とプレーンテキスト（md/txt）の
* どちらかに分岐するが、NOTE: Gemini対応のため v.union()/v.variant() は使えない
* （AIViewModelContext.ts・AIViewModelPatch.ts と同じ制約。toJsonSchema が anyOf を出力し、
* Gemini のFunction Callingスキーマではツール登録・呼び出しに失敗し得る）。
* そのため単一の v.object とし、format に応じた sheets/content の排他性は v.check で検証する。
* docx/pptx/PDF は生成非対応（モデルがツール引数として渡せるのは構造化データ/プレーンテキストのみで、
* 装飾込みの文書を原理的に再現できず生成する価値が薄いため、読み込みのみ対応する）。
*
* 上限（履歴1MB制約からの逆算。03計画 §5-1・R14）:
* - 表形式: セル合計 AI_EXPORT_FILE_MAX_CELLS 個まで・1セル AI_EXPORT_FILE_MAX_CELL_LENGTH 文字まで、csv/tsv は1シートのみ
* - テキスト: content は AI_EXPORT_TEXT_MAX_CHARS 文字まで
* - シリアライズ後の合計文字数上限（≤300,000字）は生成側（webapp の exportChatFile）で強制する
*/
const AIAssistantExportFileInput = v.pipe(v.object({
	filename: AIAssistantExportFileFilenameSchema,
	format: v.picklist([
		"xlsx",
		"csv",
		"tsv",
		"md",
		"txt"
	]),
	sheets: v.optional(v.pipe(v.array(AIAssistantExportFileSheetSchema), v.minLength(1))),
	content: v.optional(v.pipe(v.string(), v.maxLength(AI_EXPORT_TEXT_MAX_CHARS), v.check((value) => !hasDisallowedContentChar(value), "content に制御文字（改行・タブ・復帰を除く）・孤立サロゲートは使えません")))
}), v.check((input) => isExportTextFormat(input.format) ? input.content !== void 0 && input.sheets === void 0 : input.sheets !== void 0 && input.content === void 0, "format が md/txt の場合は content のみ、xlsx/csv/tsv の場合は sheets のみを指定してください（両方の指定・欠落は不可）。"), v.check((input) => isExportTextFormat(input.format) || input.format === "xlsx" || input.sheets?.length === 1, "csv / tsv は1シートのみ出力できます。複数シートが必要な場合は xlsx を使うか、ファイルを分割してください。"), v.check((input) => isExportTextFormat(input.format) || (input.sheets ?? []).reduce((n, s) => n + s.rows.reduce((m, r) => m + r.length, 0), 0) <= 5e3, `セルの合計数は ${AI_EXPORT_FILE_MAX_CELLS} 個までです。超える場合はシートやファイルを分割して出力してください。`));
const nonEmptyString = v.pipe(v.string(), v.minLength(1));
/**
* getViewImage ツールの入力スキーマ。
* viewId / viewName はどちらか一方だけを指定する。どちらも省略した場合は、
* クライアント側が直前に編集したビューまたは選択中のビューを対象にする。
*/
const AIAssistantGetViewImageInput = v.union([
	v.strictObject({}),
	v.strictObject({ viewId: nonEmptyString }),
	v.strictObject({ viewName: nonEmptyString })
]);
const AIAssistantGetViewImageImage = v.object({
	mimeType: v.literal("image/png"),
	dataBase64: v.pipe(v.string(), v.minLength(1))
});
/**
* getViewImage ツールの出力。
*
* image は履歴へ保存するときと、直近1枚を除いてリクエストへ載せないときに取り除かれるため、
* 復元した会話や過去ターンでは欠ける。
*/
const AIAssistantGetViewImageOutput = v.object({
	viewId: v.string(),
	viewName: v.string(),
	width: v.number(),
	height: v.number(),
	image: v.optional(AIAssistantGetViewImageImage)
});
/** 画像を保持している getViewImage の出力。サニタイズ対象かどうかの判定に使う。 */
const CapturedAIAssistantGetViewImageOutput = v.object({
	...AIAssistantGetViewImageOutput.entries,
	image: AIAssistantGetViewImageImage
});
/**
* クライアント側で実行されるAIアシスタントツールの定義。
* フロントエンドからインポートして利用する。
*/
const AIAssistantClientToolDefs = {
	addView: {
		name: AIAssistantToolNames.addView,
		inputSchema: AIViewModelEdit
	},
	patchView: {
		name: AIAssistantToolNames.patchView,
		inputSchema: AIViewModelPatch
	},
	switchMode: {
		name: AIAssistantToolNames.switchMode,
		inputSchema: AIAssistantSwitchModeInput
	},
	listClientSkills: {
		name: AIAssistantToolNames.listClientSkills,
		inputSchema: AIAssistantListClientSkillsInput
	},
	getClientSkill: {
		name: AIAssistantToolNames.getClientSkill,
		inputSchema: AIAssistantGetClientSkillInput
	},
	createClientSkill: {
		name: AIAssistantToolNames.createClientSkill,
		inputSchema: AIAssistantCreateClientSkillInput
	},
	updateClientSkill: {
		name: AIAssistantToolNames.updateClientSkill,
		inputSchema: AIAssistantUpdateClientSkillInput
	},
	exportFile: {
		name: AIAssistantToolNames.exportFile,
		inputSchema: AIAssistantExportFileInput
	},
	getViewImage: {
		name: AIAssistantToolNames.getViewImage,
		inputSchema: AIAssistantGetViewImageInput
	}
};
//#endregion
//#region src/ai/AIAssistantServerToolDefs.ts
/**
* サーバー側で実行されるAIアシスタントツールの定義。
* バックエンド（backend）からインポートして利用する。
*/
const AIAssistantServerToolDefs = {
	getViews: {
		name: AIAssistantToolNames.getViews,
		inputSchema: v.object({ needsPosition: v.optional(v.boolean()) }),
		outputSchema: v.object({
			name: v.string(),
			views: v.array(v.object({
				id: v.string(),
				name: v.string()
			})),
			selectedViewIds: v.optional(v.array(v.string()))
		})
	},
	getViewContent: {
		name: AIAssistantToolNames.getViewContent,
		inputSchema: v.object({ viewIds: v.array(v.string()) }),
		outputSchema: v.object({ views: v.array(AIViewModelContextView) })
	},
	getCurrentViews: {
		name: AIAssistantToolNames.getCurrentViews,
		inputSchema: v.object({}),
		outputSchema: v.object({ views: v.array(AIViewModelContextView) })
	},
	generateIds: {
		name: AIAssistantToolNames.generateIds,
		inputSchema: v.object({ count: v.pipe(v.number(), v.integer(), v.minValue(1), v.maxValue(200), v.description("採番するIDの個数")) }),
		outputSchema: v.object({ ids: v.array(v.string()) })
	}
};
//#endregion
//#region src/ai/AIAssistantMessageMetadata.ts
const AIAssistantSkillCommandSchema = v.strictObject({
	name: AIAssistantClientSkillNameSchema,
	args: v.string()
});
/**
* AIアシスタントのユーザーメッセージに付与するSkill呼び出し情報。
*
* metadataには将来ほかの情報も追加できるよう、外側はlooseObjectとして扱う。
*/
const AIAssistantSkillCommandMetadataSchema = v.looseObject({ skillCommand: AIAssistantSkillCommandSchema });
//#endregion
//#region src/ai/AIModelCatalog.ts
/**
* OpenAI の reasoning モデル（GPT-5 系）向けオプション。
* reasoningEffort で思考の深さを指定する。
*
* 注意: reasoningEffort の有効値はモデルごとに異なる（例: 'minimal' は GPT-5 のみ、GPT-5.1 以降は 'none'）。
* 'high' は reasoning モデルで広く有効なので、深い思考のプリセットには 'high' を使う。
* reasoningSummary='auto' で reasoning の要約をレスポンスに含めて取得する（人間可読の中身）。
* include の 'reasoning.encrypted_content' は継続用の暗号化コンテンツで別物。
*/
const openaiReasoning = (reasoningEffort) => ({
	reasoningEffort,
	reasoningSummary: "auto",
	include: ["reasoning.encrypted_content"],
	store: false,
	textVerbosity: "medium"
});
/**
* Gemini の thinking 設定。thinkingLevel で思考の深さを指定する（Gemini 3 系のセマンティック指定）。
* includeThoughts=true で思考要約をレスポンスに含めて取得する。
* 注意: thinkingLevel は主に Gemini 3 系で有効。Gemini 2.5 系は数値の thinkingBudget を使うため、
* ここでは Gemini 3 系・latest エイリアスにのみ割り当てる。
*/
const geminiThinking = (thinkingLevel) => ({ thinkingConfig: {
	thinkingLevel,
	includeThoughts: true
} });
const AI_MODELS = [
	{
		id: "gemini-3.8-flash",
		label: "gemini-3.8-flash",
		provider: "google",
		baseModel: "gemini-3.8-flash",
		defaultSelectable: true
	},
	{
		id: "gemini-3.7-flash",
		label: "gemini-3.7-flash",
		provider: "google",
		baseModel: "gemini-3.7-flash",
		defaultSelectable: true
	},
	{
		id: "gemini-3.1-pro-preview",
		label: "gemini-3.1-pro-preview",
		provider: "google",
		baseModel: "gemini-3.1-pro-preview"
	},
	{
		id: "gemini-pro-latest",
		label: "gemini-pro-latest",
		provider: "google",
		baseModel: "gemini-pro-latest",
		options: geminiThinking("high")
	},
	{
		id: "gemini-flash-latest",
		label: "gemini-flash-latest",
		provider: "google",
		baseModel: "gemini-flash-latest",
		defaultSelectable: true
	},
	{
		id: "gemini-flash-lite-latest",
		label: "gemini-flash-lite-latest",
		provider: "google",
		baseModel: "gemini-flash-lite-latest",
		defaultSelectable: true
	},
	{
		id: "gpt-5.6-luna",
		label: "gpt-5.6-luna",
		provider: "openai",
		baseModel: "gpt-5.6-luna",
		defaultSelectable: true
	},
	{
		id: "gpt-5.6-luna:high",
		label: "gpt-5.6-luna (effort: high)",
		provider: "openai",
		baseModel: "gpt-5.6-luna",
		options: openaiReasoning("high")
	},
	{
		id: "gpt-5.6-luna:xhigh",
		label: "gpt-5.6-luna (effort: xhigh)",
		provider: "openai",
		baseModel: "gpt-5.6-luna",
		options: openaiReasoning("xhigh")
	},
	{
		id: "gpt-5.5",
		label: "gpt-5.5",
		provider: "openai",
		baseModel: "gpt-5.5"
	},
	{
		id: "gpt-5.5:high",
		label: "gpt-5.5 (effort: high)",
		provider: "openai",
		baseModel: "gpt-5.5",
		options: openaiReasoning("high")
	},
	{
		id: "gpt-5.4",
		label: "gpt-5.4",
		provider: "openai",
		baseModel: "gpt-5.4"
	},
	{
		id: "gpt-5.4:high",
		label: "gpt-5.4 (effort: high)",
		provider: "openai",
		baseModel: "gpt-5.4",
		options: openaiReasoning("high")
	},
	{
		id: "gpt-5.4-mini",
		label: "gpt-5.4-mini",
		provider: "openai",
		baseModel: "gpt-5.4-mini",
		defaultSelectable: true
	},
	{
		id: "gpt-5.4-nano",
		label: "gpt-5.4-nano",
		provider: "openai",
		baseModel: "gpt-5.4-nano",
		defaultSelectable: true
	},
	{
		id: "gpt-5.2",
		label: "gpt-5.2",
		provider: "openai",
		baseModel: "gpt-5.2"
	},
	{
		id: "gpt-5.2:high",
		label: "gpt-5.2 (effort: high)",
		provider: "openai",
		baseModel: "gpt-5.2",
		options: openaiReasoning("high")
	},
	{
		id: "gpt-5.2-pro",
		label: "gpt-5.2-pro",
		provider: "openai",
		baseModel: "gpt-5.2-pro"
	},
	{
		id: "gpt-5.1",
		label: "gpt-5.1",
		provider: "openai",
		baseModel: "gpt-5.1",
		options: openaiReasoning("low")
	},
	{
		id: "gpt-5.1:high",
		label: "gpt-5.1 (effort: high)",
		provider: "openai",
		baseModel: "gpt-5.1",
		options: openaiReasoning("high")
	},
	{
		id: "gpt-5",
		label: "gpt-5",
		provider: "openai",
		baseModel: "gpt-5",
		options: openaiReasoning("minimal")
	},
	{
		id: "gpt-5:high",
		label: "gpt-5 (effort: high)",
		provider: "openai",
		baseModel: "gpt-5",
		options: openaiReasoning("high")
	},
	{
		id: "gpt-5-mini",
		label: "gpt-5-mini",
		provider: "openai",
		baseModel: "gpt-5-mini",
		options: openaiReasoning("minimal"),
		defaultSelectable: true
	},
	{
		id: "gpt-5-mini:high",
		label: "gpt-5-mini (effort: high)",
		provider: "openai",
		baseModel: "gpt-5-mini",
		options: openaiReasoning("high"),
		defaultSelectable: true
	},
	{
		id: "gpt-5-nano",
		label: "gpt-5-nano",
		provider: "openai",
		baseModel: "gpt-5-nano",
		options: openaiReasoning("minimal"),
		defaultSelectable: true
	}
];
/** 論理ID → 定義の索引。 */
const AI_MODEL_BY_ID = new Map(AI_MODELS.map((model) => [model.id, model]));
/** 新規チャット開始時のデフォルトモデル（論理ID）。 */
const DEFAULT_AI_MODEL_ID = "gemini-3.7-flash";
/**
* 選択可能なモデル一覧を返す。
* 既定では defaultSelectable: true のモデルのみ。includeAllModels=true（デバッグフラグ有効時）で全モデル。
*/
function getSelectableAIModels(includeAllModels) {
	return includeAllModels ? AI_MODELS : AI_MODELS.filter((model) => model.defaultSelectable);
}
/** 論理IDからモデル定義を取得する。未知のIDなら undefined。 */
function findAIModel(id) {
	return AI_MODEL_BY_ID.get(id);
}
/** 値がカタログに存在する論理IDかを判定する。 */
function isAIModelId(value) {
	return typeof value === "string" && AI_MODEL_BY_ID.has(value);
}
/**
* 論理IDに対応する providerOptions を返す（AI SDK の providerOptions 形式）。
* 例: `{ anthropic: { thinking: { type: 'adaptive' }, effort: 'xhigh' } }`
* オプション未設定、または未知のIDなら undefined。
*/
function getProviderOptions(id) {
	const def = AI_MODEL_BY_ID.get(id);
	if (!def?.options) return;
	return { [def.provider]: def.options };
}
/** 未知の baseModel を undefined として引くための参照。カタログ外のIDが来ても例外にしない。 */
const priceByBaseModel = {
	"gemini-3.8-flash": {
		inputUsdPerMTok: .75,
		cachedInputUsdPerMTok: .075,
		outputUsdPerMTok: 3.75
	},
	"gemini-3.7-flash": {
		inputUsdPerMTok: .75,
		cachedInputUsdPerMTok: .075,
		outputUsdPerMTok: 3.75
	},
	"gemini-3.1-pro-preview": {
		inputUsdPerMTok: 2,
		cachedInputUsdPerMTok: .2,
		outputUsdPerMTok: 12
	},
	"gemini-pro-latest": {
		inputUsdPerMTok: 2,
		cachedInputUsdPerMTok: .2,
		outputUsdPerMTok: 12
	},
	"gemini-flash-latest": {
		inputUsdPerMTok: .75,
		cachedInputUsdPerMTok: .075,
		outputUsdPerMTok: 3.75
	},
	"gemini-flash-lite-latest": {
		inputUsdPerMTok: .3,
		cachedInputUsdPerMTok: .03,
		outputUsdPerMTok: 2.5
	},
	"gpt-5.6-luna": {
		inputUsdPerMTok: .2,
		cachedInputUsdPerMTok: .02,
		outputUsdPerMTok: 1.2
	},
	"gpt-5.5": {
		inputUsdPerMTok: 5,
		cachedInputUsdPerMTok: .5,
		outputUsdPerMTok: 30
	},
	"gpt-5.4": {
		inputUsdPerMTok: 2.5,
		cachedInputUsdPerMTok: .25,
		outputUsdPerMTok: 15
	},
	"gpt-5.4-mini": {
		inputUsdPerMTok: .75,
		cachedInputUsdPerMTok: .075,
		outputUsdPerMTok: 4.5
	},
	"gpt-5.4-nano": {
		inputUsdPerMTok: .2,
		cachedInputUsdPerMTok: .02,
		outputUsdPerMTok: 1.25
	},
	"gpt-5.2": {
		inputUsdPerMTok: 1.75,
		cachedInputUsdPerMTok: .175,
		outputUsdPerMTok: 14
	},
	"gpt-5.2-pro": {
		inputUsdPerMTok: 21,
		cachedInputUsdPerMTok: 21,
		outputUsdPerMTok: 168
	},
	"gpt-5.1": {
		inputUsdPerMTok: 1.25,
		cachedInputUsdPerMTok: .125,
		outputUsdPerMTok: 10
	},
	"gpt-5": {
		inputUsdPerMTok: 1.25,
		cachedInputUsdPerMTok: .125,
		outputUsdPerMTok: 10
	},
	"gpt-5-mini": {
		inputUsdPerMTok: .25,
		cachedInputUsdPerMTok: .025,
		outputUsdPerMTok: 2
	},
	"gpt-5-nano": {
		inputUsdPerMTok: .05,
		cachedInputUsdPerMTok: .005,
		outputUsdPerMTok: .4
	}
};
/**
* 円換算に使う為替レート。市場レートを追随する値ではなく、計測の基準として固定した値。
* リクエスト完了時にこのレートで円に焼き込むので、ここを変えても過去の記録は動かない（以後の計上にだけ効く）。
*/
const USD_JPY_RATE = 160;
const TOKENS_PER_M = 1e6;
/** 未指定は0として扱い（内数の未報告を許す）、トークン数として成立しない値（NaN・Infinity・負数）は null で表す。 */
const normalizeTokenCount = (value) => {
	if (value === void 0) return 0;
	return Number.isFinite(value) && value >= 0 ? value : null;
};
/**
* 論理モデルIDとトークン使用量から、リクエスト1回分の利用額（円）を算出する。
* 金額を確定できないとき（カタログにないモデルID、トークン数が壊れている、使用量が報告されていない）は
* null を返す。呼び出し側は「計上しない」か「拒否する」かを選べるが、0円として扱ってはいけない。
*
* 戻り値は端数を丸めない円。表示側で丸める前提で、カウンタには生の値を積む。
*
* `inputTokens` は `cachedInputTokens` を含む合計、`outputTokens` は reasoning を含む合計
* （AI SDK の usage 仕様。openai/google プロバイダのマッピングと Mastra の集計で確認済み）。
* そのためキャッシュ分は入力から差し引いてキャッシュ単価で、reasoning は出力に含めたまま計上する。
*/
function calcAIUsageCostYen(modelId, usage) {
	const baseModel = findAIModel(modelId)?.baseModel;
	const price = baseModel ? priceByBaseModel[baseModel] : void 0;
	if (!price) return null;
	if (usage.inputTokens === void 0 && usage.outputTokens === void 0) return null;
	const inputTokens = normalizeTokenCount(usage.inputTokens);
	const outputTokens = normalizeTokenCount(usage.outputTokens);
	const reportedCachedInputTokens = normalizeTokenCount(usage.cachedInputTokens);
	if (inputTokens === null || outputTokens === null || reportedCachedInputTokens === null) return null;
	const cachedInputTokens = Math.min(reportedCachedInputTokens, inputTokens);
	return ((inputTokens - cachedInputTokens) * price.inputUsdPerMTok + cachedInputTokens * price.cachedInputUsdPerMTok + outputTokens * price.outputUsdPerMTok) / TOKENS_PER_M * USD_JPY_RATE;
}
//#endregion
//#region src/ai/AIUsageLimit.ts
/**
* 月間AI利用上限に達したときに `/api/aichat` が 429 とともに返す本文。
* AI SDK の useChat はレスポンス本文をそのまま Error の message にするため、
* クライアントはこの文字列で「上限到達」と通常の接続エラーを見分ける。
*/
const AI_USAGE_LIMIT_EXCEEDED_MESSAGE = "Usage Limit Exceeded";
//#endregion
//#region src/ai/omitNullFields.ts
/**
* AIツール呼び出しの入力から、値が null のフィールドを取り除く。
*
* OpenAI の Structured Outputs は全フィールドを required として扱い、省略可能な項目は
* nullable で表現するため、モデルは「値なし」を null として送ってくる。
* valibot の v.optional() は undefined しか受け付けず null はバリデーションエラーになるので、
* パース前にこの関数で落として「省略された」状態に揃える。
*
* AIツールのスキーマに null を意味のある値として扱う項目はないため、一律で取り除いてよい。
*/
function omitNullFields(input) {
	if (Array.isArray(input)) return input.map((item) => omitNullFields(item));
	if (input === null || typeof input !== "object") return input;
	const result = {};
	for (const [key, value] of Object.entries(input)) {
		if (value === null) continue;
		result[key] = omitNullFields(value);
	}
	return result;
}
//#endregion
//#region src/ai/normalizeAIEditLinkThemeColors.ts
/** 置き換えの説明で列挙する該当箇所の上限。 */
const MAX_PATHS_PER_REPLACEMENT = 5;
function isRecord(value) {
	return typeof value === "object" && value !== null && !Array.isArray(value);
}
/**
* 編集系ツール(addView/patchView)の入力から、リンクに指定できない色を
* 指定できる3色へ寄せる。パース前に呼ぶことを想定している。
*
* リンクの色は Gray / Red / Blue の3色しかないのに対し、付箋・ゾーンのテーマカラーは8色ある。
* AIは付箋の色の感覚のままリンクにも Green / Purple などを指定しがちで、その都度スキーマエラーで
* 差し戻すと同じ間違いを繰り返して編集が進まない。色は装飾であり、寄せても図の意味は壊れないため、
* ここで補正して編集を通し、何をどう置き換えたかは戻り値の replacements からAIへ伝える。
*
* 補正するのはリンクの themeColor に文字列が入っている場合だけで、項目自体が無い場合や
* 付箋・ゾーンの色は触らない（それらは今までどおりバリデーションで差し戻す）。
*/
function normalizeAIEditLinkThemeColors(input) {
	const replacements = [];
	if (!isRecord(input) || !Array.isArray(input.views)) return {
		input,
		replacements
	};
	const views = input.views.map((view, viewIndex) => {
		if (!isRecord(view) || !Array.isArray(view.links)) return view;
		const links = view.links.map((link, linkIndex) => {
			if (!isRecord(link) || !isRecord(link.style)) return link;
			const themeColor = link.style.themeColor;
			if (typeof themeColor !== "string") return link;
			if (AIViewModelContextLinkUtils.parseThemeColor(themeColor)) return link;
			const normalized = AIViewModelContextLinkUtils.normalizeThemeColor(themeColor);
			replacements.push({
				path: `views[${viewIndex}].links[${linkIndex}]`,
				from: themeColor,
				to: normalized
			});
			return {
				...link,
				style: {
					...link.style,
					themeColor: normalized
				}
			};
		});
		return {
			...view,
			links
		};
	});
	return {
		input: {
			...input,
			views
		},
		replacements
	};
}
/** リンク色の置き換え内容を、AIへ返すツール実行結果の補足文言に整形する。 */
function formatAILinkThemeColorReplacements(replacements) {
	if (replacements.length === 0) return "";
	const pathsByReplacement = /* @__PURE__ */ new Map();
	for (const replacement of replacements) {
		const key = `${replacement.from} → ${replacement.to}`;
		pathsByReplacement.set(key, [...pathsByReplacement.get(key) ?? [], replacement.path]);
	}
	return "リンクの色に指定できない値があったため、次のように置き換えて適用しました。リンクの色は Gray / Red / Blue の3色だけで、付箋・ゾーンのテーマカラーは使えません。\n" + [...pathsByReplacement].map(([replacement, paths]) => {
		const shown = paths.slice(0, MAX_PATHS_PER_REPLACEMENT);
		const omitted = paths.length - shown.length;
		return `- ${replacement}（${paths.length}件: ${shown.join(", ")}${omitted > 0 ? `, ほか${omitted}件` : ""}）`;
	}).join("\n") + "\n以降のリンクはこの3色から選んでください。置き換えた色が意図と違う場合は patchView で修正してください。";
}
//#endregion
export { AIAssistantClientSkillIdSchema, AIAssistantClientSkillInputSchema, AIAssistantClientSkillNameSchema, AIAssistantClientSkillSchema, AIAssistantClientSkillTriggerSchema, AIAssistantClientSkillsSchema, AIAssistantClientToolDefs, AIAssistantCreateClientSkillInput, AIAssistantExportFileInput, AIAssistantGetClientSkillInput, AIAssistantGetViewImageImage, AIAssistantGetViewImageInput, AIAssistantGetViewImageOutput, AIAssistantListClientSkillsInput, AIAssistantModes, AIAssistantServerToolDefs, AIAssistantSkillCommandMetadataSchema, AIAssistantSkillCommandSchema, AIAssistantSwitchModeInput, AIAssistantToolNames, AIAssistantUpdateClientSkillInput, AIAssistantViewModelSkillSchema, AIAssistantViewModelSkillsSchema, AIViewModelContextConsistencyLink, AIViewModelContextDescriptionPanel, AIViewModelContextLink, AIViewModelContextLinkBend, AIViewModelContextLinkLineStyle, AIViewModelContextLinkMarkStyle, AIViewModelContextLinkMultiplicity, AIViewModelContextLinkStyle, AIViewModelContextLinkThemeColor, AIViewModelContextLinkUtils, AIViewModelContextSchema, AIViewModelContextStickyNode, AIViewModelContextStickyNodeReactions, AIViewModelContextStickyNodeStyle, AIViewModelContextThemeColor, AIViewModelContextUtils, AIViewModelContextView, AIViewModelContextZone, AIViewModelContextZoneFontSize, AIViewModelContextZoneShape, AIViewModelContextZoneTextAlign, AIViewModelContextZoneTitlePosition, AIViewModelEdit, AIViewModelEditUtils, AIViewModelPatch, AIViewModelPatchView, AI_ASSISTANT_MEMBER_SETTINGS_MAX_PER_REQUEST, AI_EXPORT_FILE_MAX_CELLS, AI_EXPORT_FILE_MAX_CELL_LENGTH, AI_EXPORT_TEXT_MAX_CHARS, AI_MODELS, AI_USAGE_LIMIT_EXCEEDED_MESSAGE, ActionLogEventDefinitions, ActiveClientSessionSchema, AnnotationLinkSchema, AnnotationLinkStyles, AnonymousUserSchema, AssignedGroupIndexSchema, AssignedGroupIndexValueSchema, AuthCustomClaimSchema, AuthSessionSchema, BillingMethodSchema, BillingOperationActionSchema, BillingOperationRequesterRoleSchema, BillingOperationSchema, BillingOperationStatusSchema, BillingRevisionSchema, CapturedAIAssistantGetViewImageOutput, DEFAULT_AI_ASSISTANT_MODE, DEFAULT_AI_MODEL_ID, DEFAULT_AI_USAGE_ALLOCATION_RATE_PERCENT, DEFAULT_MODELING_FORMAT, FileContainerSchema, GROUP_LICENSE_PERMISSIONS, GROUP_LICENSE_TYPE_DICT, GroupBillingCheckoutAttemptSchema, GroupBillingProfileSchema, GroupLicenseNotificationCompletedJobSchema, GroupLicenseSchema, GroupLicenseTypeSchema, GroupLicenseUpdateLogSchema, GroupMemberInvitationAcceptanceSchema, GroupMemberInvitationSchema, GroupMemberInvitationWorkspacesSchema, GroupMemberRoleSchema, GroupMemberRolesSchema, GroupSchema, MAX_GLOBAL_AI_USAGE_ALLOCATION_RATE_PERCENT, MAX_GROUP_AI_USAGE_ALLOCATION_RATE_PERCENT, MIN_AI_USAGE_ALLOCATION_RATE_PERCENT, MODEL_GRID_SIZE, ModelingFormatList, ModelingFormatSchema, NO_ASSIGN, OperatorSchema, PasswordStrengthOptions, PrivateAIAssistantChatMessageIdSchema, PrivateAIAssistantChatMessageRoleSchema, PrivateAIAssistantChatMessageSchema, PrivateAIAssistantChatThreadIdSchema, PrivateAIAssistantChatThreadSchema, RTDBPath, ReleaseToggleDefinitions, ReleaseToggleNames, StickyNodeSizeByModelingFormat, StoragePath, StripeEventProcessingSchema, StripeIdGroupIndexValueSchema, StripeSubscriptionStatusSchema, UserAuthProviderGoogleSchema, UserAuthProviderMicrosoftSchema, UserAuthProviderSchema, UserCredentialSchema, UserEntitySchema, UserLoginIdentifierSchema, UserMailAddressChangeTokenSchema, UserOnboardingGuideCompletedJobSchema, UserOnboardingGuideStoppedSchema, UserOneTimePasswordSchema, UserPasswordResetTokenSchema, UserPublicProfileSchema, UserSignUpRequestTokenSchema, UserSurveyAnswerSchema, VIEW_GRID_SIZE, VIEW_MODEL_CANVAS_BOUNDS, VIEW_MODEL_CANVAS_SIZE, ViewModelFileStorageLimitBytes, ViewModelIndividualPermissionRoleSchema, ViewModelIndividualPermissionRolesSchema, ViewModelSchema, WorkspaceMemberRoleSchema, WorkspaceMemberRolesSchema, WorkspaceSchema, calcAIUsageCostYen, canEditViewModel, defaultIpRestrictionConfiguration, extractId, findAIModel, formatAILinkThemeColorReplacements, getProviderOptions, getSelectableAIModels, getUserLoginIdentifierFromEmail, isAIAssistantMode, isAIModelId, isReservedBundledAIAssistantSkillName, isValidGlobalAIUsageAllocationRatePercent, isValidGroupAIUsageAllocationRatePercent, isValidId, normalizeAIEditLinkThemeColors, omitNullFields, snapPositionToModelGrid, snapToModelGrid, timestampISOStringSchema, timestampSchema, toSkillSummary, undefinedToNullField };

//# sourceMappingURL=index.mjs.map